const stockist_locations = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -3.675156,
          50.582065
        ]
      },
      "properties": {
        "title": "The Barbecue Shack",
        "description": "The Barbecue Shack",
        "address": "The Old Kiln, Pottery Rd, Bovey Tracey, TQ13 9DS, United Kingdom",
        "city": "Bovey Tracey",
        "state_province": "United Kingdom",
        "postal_code": "TQ13 9DS",
        "country": "United Kingdom",
        "phone": "+44 1626 834233",
        "website": "https://www.thebbqshack.co.uk/",
        "gmaps_uri": "https://maps.google.com/?cid=15480175223175587043&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -1.219724,
          51.180768
        ]
      },
      "properties": {
        "title": "Namibian Hardwood | UK",
        "description": "Namibian Hardwood | UK",
        "address": "Unit 2, Bradley Farm, Micheldever, SO21 3BQ, United Kingdom",
        "city": "Micheldever",
        "state_province": "United Kingdom",
        "postal_code": "SO21 3BQ",
        "country": "United Kingdom",
        "website": "https://namibianhardwood.co.uk/",
        "gmaps_uri": "https://maps.google.com/?cid=12691486770044677804&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          0.449533,
          51.313086
        ]
      },
      "properties": {
        "title": "NORTH Outdoor Living and BBQ",
        "description": "NORTH Outdoor Living and BBQ",
        "address": "Units 5,10 & 11 Brook House, New Hythe Lane, Aylesford, Kent, ME20 6GN, United Kingdom",
        "city": "Kent",
        "state_province": "United Kingdom",
        "postal_code": "ME20 6GN",
        "country": "United Kingdom",
        "website": "https://www.northbarbeque.co.uk/",
        "gmaps_uri": "https://maps.google.com/?cid=15443067932396654144&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          14.497791,
          -22.9598
        ]
      },
      "properties": {
        "title": "Superspar | Walvis Bay",
        "description": "Superspar | Walvis Bay",
        "address": "102 Sam Nujoma Ave, Walvis Bay, Walvis Baai, Namibia, 13013, Namibia",
        "city": "Walvis Baai",
        "state_province": "Namibia",
        "postal_code": "13013",
        "country": "Namibia",
        "phone": "+264 64 202 648",
        "website": "https://www.spar.co.za/Home/Store-View/SUPERSPAR-Walvis-Bay-Protea-Namibia",
        "email": "nelia@sparwvb.com",
        "regions": [
          "Namibia"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14817942355907936189&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          14.525089,
          -22.677108
        ]
      },
      "properties": {
        "title": "Slowtown Coffee Roasters | Swakopmund",
        "description": "Slowtown Coffee Roasters | Swakopmund",
        "address": "Crn Daniel Tjongarero Ave & Tobias Hainyeko, Swakopmund, Western Namibia, 13001, Namibia",
        "city": "Swakopmund",
        "state_province": "Namibia",
        "postal_code": "13001",
        "country": "Namibia",
        "phone": "+264818643788",
        "website": "https://slowtowncoffee.com/stores/store-swakopmund/",
        "regions": [
          "Namibia"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8615085457372777045&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          16.651366,
          -20.462318
        ]
      },
      "properties": {
        "title": "Theo's Superspar",
        "description": "Theo's Superspar",
        "address": "12004, B1, Otjiwarongo, Otjiwarongo, Namibia, Namibia",
        "city": "Otjiwarongo",
        "state_province": "Namibia",
        "postal_code": "",
        "country": "Namibia",
        "phone": "+264 67 303 187",
        "website": "https://www.spar.co.za/home/store-view/superspar-theos-namibia",
        "email": "rehuel@me.com",
        "regions": [
          "Namibia"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7686572833263093843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          17.0932,
          -22.621546
        ]
      },
      "properties": {
        "title": "Outdoor Centre | Windhoek",
        "description": "Outdoor Centre | Windhoek",
        "address": "Shop 1, Hilltop Village, The Grove Mall of Namibia, Windhoek, Khomas Region, 10005, Namibia",
        "city": "Windhoek",
        "state_province": "Namibia",
        "postal_code": "10005",
        "country": "Namibia",
        "phone": "+264 61 241 367",
        "website": "https://www.outdoorcentre.com.na/",
        "email": "buying@outdoorcentre.com.na",
        "regions": [
          "Namibia"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7005061862809928752&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          17.889288,
          -32.809862
        ]
      },
      "properties": {
        "title": "Paternoster Wine Lounge",
        "description": "Paternoster Wine Lounge",
        "address": "54 St Augustine Rd, Kliprug, Paternoster, Western Cape, 7381, South Africa",
        "city": "Paternoster",
        "state_province": "Western Cape",
        "postal_code": "7381",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6394459999802747636&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          17.985806,
          -32.92633
        ]
      },
      "properties": {
        "title": "Wolf Customs",
        "description": "Wolf Customs",
        "address": "Unit 16, 27 Sterling Rd, Marais Industria, Vredenburg, Western Cape, 7380, South Africa",
        "city": "Vredenburg",
        "state_province": "Western Cape",
        "postal_code": "7380",
        "country": "South Africa",
        "phone": "0713640670",
        "website": "https://www.wolfcustoms.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6868284077622053819&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          17.982512,
          -32.92642
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Vredenburg",
        "description": "Outdoor Warehouse | Vredenburg",
        "address": "Unit 5, Corner of West Ridge Boulevard & Saldanha Road, Vredenburg, Vredenburg, Western Cape, 7380, South Africa",
        "city": "Vredenburg",
        "state_province": "Western Cape",
        "postal_code": "7380",
        "country": "South Africa",
        "phone": "021 180 5504",
        "email": "vredenburg@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7881034035342835986&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.148844,
          -32.787653
        ]
      },
      "properties": {
        "title": "3DOM and Co",
        "description": "3DOM and Co",
        "address": "Marina Centre, Port Owen, Velddrif, Western Cape, 7365, South Africa",
        "city": "Velddrif",
        "state_province": "Western Cape",
        "postal_code": "7365",
        "country": "South Africa",
        "phone": "087 550 1441",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11860053618679788588&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.2387,
          -33.334665
        ]
      },
      "properties": {
        "title": "Weskus Padstal",
        "description": "Weskus Padstal",
        "address": "R27 & R315, Yzerfontein, Western Cape, 7345, South Africa",
        "city": "Yzerfontein",
        "state_province": "Western Cape",
        "postal_code": "7345",
        "country": "South Africa",
        "phone": "021 065 1867",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7699353878983574669&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.357286,
          -34.042721
        ]
      },
      "properties": {
        "title": "NAP Living | Hout Bay",
        "description": "NAP Living | Hout Bay",
        "address": "Shop C3 Mainstream Ctr, Princess St, Hout Bay, Cape Town, Western Cape, 7806, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7806",
        "country": "South Africa",
        "phone": "021 790 1478",
        "website": "https://www.napliving.co.za/?srsltid=AfmBOoqF6iIrT-iQUMMBgFm_XVL9adkn9ma5UH3dMQs532uxuRV31thZ",
        "email": "info@napliving.co.za.",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13869903750803519026&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.396666,
          -33.908206
        ]
      },
      "properties": {
        "title": "Frankie Fenner | Sea Point",
        "description": "Frankie Fenner | Sea Point",
        "address": "2 Penarth Rd, Three Anchor Bay, Cape Town, Western Cape, 8005, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "8005",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7640355231828320794&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.410815,
          -33.908379
        ]
      },
      "properties": {
        "title": "Jason Bakery",
        "description": "Jason Bakery",
        "address": "83 Main Rd, Green Point, Cape Town, Western Cape, 8005, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "8005",
        "country": "South Africa",
        "phone": "021 433 0538",
        "website": "https://jasonbakery.com/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3002058405734194735&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.418221,
          -33.912473
        ]
      },
      "properties": {
        "title": "Melvill & Moon",
        "description": "Melvill & Moon",
        "address": "74 Prestwich St, De Waterkant, Cape Town, Western Cape, 8001, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "8001",
        "country": "South Africa",
        "phone": "0696800120",
        "website": "http://www.melvillandmoon.com/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12497702510940793603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.41734,
          -33.934409
        ]
      },
      "properties": {
        "title": "Frankie Fenner | Gardens",
        "description": "Frankie Fenner | Gardens",
        "address": "Buitenkant St, Oranjezicht, Cape Town, Western Cape, 8001, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "8001",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13344495191045549943&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.418146,
          -33.934557
        ]
      },
      "properties": {
        "title": "Yuppiechef | Gardens",
        "description": "Yuppiechef | Gardens",
        "address": "Buitenkant St, Gardens, Cape Town, Cape Town, Western Cape, 8001, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "8001",
        "country": "South Africa",
        "phone": "+27212017346",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3645401526371807304&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.421138,
          -34.133139
        ]
      },
      "properties": {
        "title": "Central Mica Hardware | Fish Hoek",
        "description": "Central Mica Hardware | Fish Hoek",
        "address": "Valyland Shopping Centre, Kinross Cres, Fish Hoek, Cape Town, Western Cape, 7974, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7974",
        "country": "South Africa",
        "phone": "021 782 1131",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12824697420989844773&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.420134,
          -33.903794
        ]
      },
      "properties": {
        "title": "Yuppiechef | V&A Waterfront",
        "description": "Yuppiechef | V&A Waterfront",
        "address": "V&A Waterfront, Cape Town, Western Cape, 8001, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "8001",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7682263222629001271&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.423851,
          -33.928571
        ]
      },
      "properties": {
        "title": "Just Like Papa",
        "description": "Just Like Papa",
        "address": "73 Harrington St, District Six, Cape Town, Western Cape, 7925, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7925",
        "country": "South Africa",
        "phone": "087 470 0216",
        "website": "https://justlikepapa.com/",
        "email": "hello@donkeylongtong.com",
        "logo_url": "https://cdn.shopify.com/s/files/1/0580/4644/7772/files/294573656_550876873265967_6999936205396241340_n.jpg?v=1700650665",
        "priority": "1",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9064689361225538284&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.431624,
          -34.073274
        ]
      },
      "properties": {
        "title": "Inhouse - The Kitchen Shop | Tokai",
        "description": "Inhouse - The Kitchen Shop | Tokai",
        "address": "Steenberg Village Shopping Centre Shop G8, Cnr Reddam & Steenberg Roads, Tokai, Cape Town, Western Cape, 7945, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7945",
        "country": "South Africa",
        "phone": "078 817 6298",
        "website": "http://www.thekitchenshop.co.za",
        "email": "admin@inhousestfrancis.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18298348960110517985&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.437498,
          -34.079402
        ]
      },
      "properties": {
        "title": "Yuppiechef | Westlake",
        "description": "Yuppiechef | Westlake",
        "address": "Westlake Outlet Store, 5 Bell Crescent, Westlake Business Park, Westlake, Cape Town, Cape Town, Western Cape, 7945, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7945",
        "country": "South Africa",
        "phone": "+27218790929",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9641739282411554683&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.438267,
          -34.079948
        ]
      },
      "properties": {
        "title": "Ryan Boon Speciality M.eat | Westlake",
        "description": "Ryan Boon Speciality M.eat | Westlake",
        "address": "Westlake Lifestyle Centre Cnr Bell Crescent & Westlake Drive Westlake, Westlake, Western Cape, 7945, South Africa",
        "city": "Westlake",
        "state_province": "Western Cape",
        "postal_code": "7945",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15878618138106523864&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.440494,
          -33.73011
        ]
      },
      "properties": {
        "title": "Melkbos Tops",
        "description": "Melkbos Tops",
        "address": "Shop 14, Cnr Beach Road & 6th Avenue, Melkbos, Western Cape, 7441, South Africa",
        "city": "Melkbos",
        "state_province": "Western Cape",
        "postal_code": "7441",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16725072944860138197&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.439376,
          -33.927481
        ]
      },
      "properties": {
        "title": "Frankie Fenner Meat Merchant | Woodstock",
        "description": "Frankie Fenner Meat Merchant | Woodstock",
        "address": "143 Sir Lowry Rd, Woodstock, Cape Town, Western Cape, 7915, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7915",
        "country": "South Africa",
        "phone": "0215699652",
        "website": "http://www.ffmm.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16043900808575965438&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.444627,
          -34.021917
        ]
      },
      "properties": {
        "title": "Yuppiechef | Constantia Village",
        "description": "Yuppiechef | Constantia Village",
        "address": "Yuppiechef - Constantia Village, Shop #21, The Constantia Village, Spaanschemat River Rd, Constantia, Constantia, Western Cape, 7800, South Africa",
        "city": "Constantia",
        "state_province": "Western Cape",
        "postal_code": "7800",
        "country": "South Africa",
        "phone": "+27212035904",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11721804848568777142&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.450683,
          -34.064123
        ]
      },
      "properties": {
        "title": "Trans Africa Tours",
        "description": "Trans Africa Tours",
        "address": "Medicross Driveway Tokai Business Park, 13 A Keyser River Dr, Tokai, Cape Town, Western Cape, 7945, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7945",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8994550500029905296&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.455786,
          -34.080753
        ]
      },
      "properties": {
        "title": "Namibian Hardwood | Lakeside",
        "description": "Namibian Hardwood | Lakeside",
        "address": "460 Main Road, Lakeside, Cape Town, Western Cape, 7945, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7945",
        "country": "South Africa",
        "phone": "0219792051",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8323481477384059816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.45836,
          -34.064198
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Tokai",
        "description": "Outdoor Warehouse | Tokai",
        "address": "Shop 02, Tokai-On-Main Centre, Main Road, Cape Town, Cape Town, Western Cape, 7945, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7945",
        "country": "South Africa",
        "phone": "(021) 180 5448",
        "email": "tokai@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4603449716309862962&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.46372,
          -33.980237
        ]
      },
      "properties": {
        "title": "Yuppiechef | Cavendish",
        "description": "Yuppiechef | Cavendish",
        "address": "Cavendish Square, 1 Dreyer St, Claremont, Cape Town, Western Cape, 7708, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7708",
        "country": "South Africa",
        "phone": "0212038688",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7333474113006704179&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.464055,
          -33.971272
        ]
      },
      "properties": {
        "title": "Ryan Boon Speciality M.eat | Newlands",
        "description": "Ryan Boon Speciality M.eat | Newlands",
        "address": "Dean St, Newlands, Cape Town, Western Cape, 7725, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7725",
        "country": "South Africa",
        "phone": "0724718129",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17202724267345610078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.47163,
          -33.909847
        ]
      },
      "properties": {
        "title": "The Barn - Donkey Factory Shop",
        "description": "The Barn - Donkey Factory Shop",
        "address": "48 Marine Drive, Paarden Eiland, Cape Town, Western Cape, 7405, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7405",
        "country": "South Africa",
        "phone": "0724920929",
        "website": "http://www.donkeylongtong.co.za",
        "email": "hello@donkeylongtong.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9967386301380737920&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.478066,
          -33.786497
        ]
      },
      "properties": {
        "title": "Yuppiechef | Table Bay",
        "description": "Yuppiechef | Table Bay",
        "address": "Table Bay Mall, R27, Corner of, Berkshire Blvd, Sunningdale, Cape Town, Cape Town, Western Cape, 7441, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7441",
        "country": "South Africa",
        "phone": "021 140 8753",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15240505192931973836&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.487791,
          -33.803706
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | West Coast",
        "description": "Outdoor Warehouse | West Coast",
        "address": "Sunningdale Dr, Sunningdale Lifestyle Centre, Parklands, Cape Town, Western Cape, Cape Town, Western Cape, 7441, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7441",
        "country": "South Africa",
        "phone": "021 554 3245",
        "email": "admin-westcoast@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13290547369245812871&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.492302,
          -33.955968
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Rondebosch",
        "description": "Outdoor Warehouse | Rondebosch",
        "address": "34 Klipfontein Rd, Rondebosch, Cape Town, Western Cape, 7700, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7700",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11170406710677345259&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.509656,
          -33.933923
        ]
      },
      "properties": {
        "title": "Flame Store",
        "description": "Flame Store",
        "address": "Shop 11, Founders Quarter, Founders Way, Pinelands, Cape Town, Western Cape, 7405, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7405",
        "country": "South Africa",
        "phone": "082 329 2038",
        "website": "https://flamestore.co.za",
        "email": "sales@flamestore.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12037079471927741245&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.510424,
          -33.893819
        ]
      },
      "properties": {
        "title": "Yuppiechef | Canal Walk",
        "description": "Yuppiechef | Canal Walk",
        "address": "Yuppiechef - Canal Walk, 556, Shop 554 &, 490 Century Blvd, Century City, Cape Town, Western Cape, 7446, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7446",
        "country": "South Africa",
        "phone": "+27212035906",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7194216383226294433&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.555824,
          -33.89451
        ]
      },
      "properties": {
        "title": "Safari Centre Cape Town - 4x4 Accessory & Camping Centre",
        "description": "Safari Centre Cape Town - 4x4 Accessory & Camping Centre",
        "address": "Shop 9, N1 Motor City, Goodwood, Cape Town, Western Cape, 7463, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7463",
        "country": "South Africa",
        "phone": "021 595 3910",
        "website": "https://www.safaricentrecapetown.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18200872066689617289&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.578463,
          -33.8739
        ]
      },
      "properties": {
        "title": "Spar Plattekloof",
        "description": "Spar Plattekloof",
        "address": "Corner Olienhout & Plattekloof Roads, Plattekloof Rd., Cape Town, Western Cape, 7500, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7500",
        "country": "South Africa",
        "phone": "021 911 1010",
        "website": "https://www.spar.co.za/home/store-view/spar-plattekloof-western-cape",
        "email": "plattekloof4@retail.spar.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14409953659953166330&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.629811,
          -33.895037
        ]
      },
      "properties": {
        "title": "Tafelberg Furniture | Bellville",
        "description": "Tafelberg Furniture | Bellville",
        "address": "126, 128 Durban Road, Bellville, Cape Town, Western Cape, 7530, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7530",
        "country": "South Africa",
        "phone": "0219443330",
        "website": "http://www.tafelberg.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4909466138875689669&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.632832,
          -33.86814
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Bellville",
        "description": "Outdoor Warehouse | Bellville",
        "address": "Shop 1, Willowbridge North SH/Centre, CNR Old Oak Road & Carl Cronje Drive Tyger Valley, Bellville, Western Cape, 7530, South Africa",
        "city": "Bellville",
        "state_province": "Western Cape",
        "postal_code": "7530",
        "country": "South Africa",
        "phone": "(021) 914 1357",
        "email": "bellville@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7794250557159578380&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.63175,
          -33.870078
        ]
      },
      "properties": {
        "title": "Yuppiechef | Willowbridge",
        "description": "Yuppiechef | Willowbridge",
        "address": "Shop G43-45, Willowbridge, 39 Carl Cronje Dr, Tygervalley, Cape Town, Cape Town, Western Cape, 7530, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7530",
        "country": "South Africa",
        "phone": "+27212005935",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1447809117599817118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.63528,
          -33.882723
        ]
      },
      "properties": {
        "title": "The Grounds Meat & Deli",
        "description": "The Grounds Meat & Deli",
        "address": "76 Edward Rd, Bellville, Bellville, Western Cape, 7530, South Africa",
        "city": "Bellville",
        "state_province": "Western Cape",
        "postal_code": "7530",
        "country": "South Africa",
        "phone": "0870879954",
        "website": "https://grounds.co.za/",
        "logo_url": "https://cdn.shopify.com/s/files/1/0580/4644/7772/files/The_Grounds_Brand_Board.jpg?v=1712702657",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14245380760481830803&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.646912,
          -33.832845
        ]
      },
      "properties": {
        "title": "Bali Trading | Durbanville",
        "description": "Bali Trading | Durbanville",
        "address": "27B Main Rd, Durbanville, Durbanville, Western Cape, 7550, South Africa",
        "city": "Durbanville",
        "state_province": "Western Cape",
        "postal_code": "7550",
        "country": "South Africa",
        "phone": "0215180715",
        "website": "https://www.lifestyleatbalitrading.co.za/",
        "email": "jeanine@balitrading.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18002130005595915872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.65033,
          -33.908593
        ]
      },
      "properties": {
        "title": "4Matt Campers",
        "description": "4Matt Campers",
        "address": "27 Proton Cres, Triangle Farm, Cape Town, Western Cape, 7530, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7530",
        "country": "South Africa",
        "phone": "0210651815",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=267821364127517913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.650543,
          -33.828404
        ]
      },
      "properties": {
        "title": "M.Eat Biltong & Deli | Clara Anna",
        "description": "M.Eat Biltong & Deli | Clara Anna",
        "address": "33 Wellington Rd, Durbanville, Cape Town, Western Cape, 7551, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7551",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4608973376771600573&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.650715,
          -33.829072
        ]
      },
      "properties": {
        "title": "Agrimark | Durbanville",
        "description": "Agrimark | Durbanville",
        "address": "30 Wellington Rd, Durbanville, Durbanville, Western Cape, 7551, South Africa",
        "city": "Durbanville",
        "state_province": "Western Cape",
        "postal_code": "7551",
        "country": "South Africa",
        "phone": "0219763057",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15872289449117003944&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.682633,
          -33.908905
        ]
      },
      "properties": {
        "title": "Die Braai Gat",
        "description": "Die Braai Gat",
        "address": "Cnr Amandel & Bottelary road, Soneieke, Kuils River, Western Cape, 7580, South Africa",
        "city": "Kuils River",
        "state_province": "Western Cape",
        "postal_code": "7580",
        "country": "South Africa",
        "phone": "066 266 1805",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16803562810513446356&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.689357,
          -33.800908
        ]
      },
      "properties": {
        "title": "Phesantekraal Superspar",
        "description": "Phesantekraal Superspar",
        "address": "Cnr of Klipheuwel, Okovango Rd, Durbanville, Durbanville, Western Cape, 7550, South Africa",
        "city": "Durbanville",
        "state_province": "Western Cape",
        "postal_code": "7550",
        "country": "South Africa",
        "email": "wjjforbes@gmail.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10160122930553245528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.700088,
          -33.861826
        ]
      },
      "properties": {
        "title": "AXL Outdoor",
        "description": "AXL Outdoor",
        "address": "13 Kingfisher Cres, Okavango Park, Cape Town, Western Cape, 7560, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7560",
        "country": "South Africa",
        "phone": "0217454884",
        "website": "https://axloutdoor.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10769836067347144493&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.703366,
          -33.789629
        ]
      },
      "properties": {
        "title": "Namibian Hardwood | Durbanville",
        "description": "Namibian Hardwood | Durbanville",
        "address": "12 Oostenberg Street, Durbanville Industria, Cape Town, Western Cape, 7550, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7550",
        "country": "South Africa",
        "phone": "0219792051",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6534889491395617084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.72899,
          -33.462797
        ]
      },
      "properties": {
        "title": "Agrimark | Malmesbury",
        "description": "Agrimark | Malmesbury",
        "address": "Ground Floor, 65 Voortrekker Rd, Malmesbury, Western Cape, 7300, South Africa",
        "city": "Malmesbury",
        "state_province": "Western Cape",
        "postal_code": "7300",
        "country": "South Africa",
        "phone": "0224828000",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15878732413070407370&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.730142,
          -33.454876
        ]
      },
      "properties": {
        "title": "PET Pool & Fire | Malmesbury",
        "description": "PET Pool & Fire | Malmesbury",
        "address": "Voortrekker & Piketberg Street, Malmesbury, Western Cape, 7300, South Africa",
        "city": "Malmesbury",
        "state_province": "Western Cape",
        "postal_code": "7300",
        "country": "South Africa",
        "phone": "010 746 4926",
        "website": "https://www.petandpool.co.za",
        "email": "malmesbury@petandpool.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17433112634862985185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.756534,
          -32.907756
        ]
      },
      "properties": {
        "title": "Superspar | Boland",
        "description": "Superspar | Boland",
        "address": "54 Lang Street, Piketberg, Western Cape, 7320, South Africa",
        "city": "Piketberg",
        "state_province": "Western Cape",
        "postal_code": "7320",
        "country": "South Africa",
        "phone": "022 913 1163",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8105849474766583643&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.785695,
          -33.970628
        ]
      },
      "properties": {
        "title": "Spier Wine Farm | Cowshed",
        "description": "Spier Wine Farm | Cowshed",
        "address": "R310 Baden Powell Dr, Lynedoch, Stellenbosch, Western Cape, 7603, South Africa",
        "city": "Stellenbosch",
        "state_province": "Western Cape",
        "postal_code": "7603",
        "country": "South Africa",
        "phone": "0218091142",
        "website": "https://www.spier.co.za/food/farm-cafe",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9938171271610707891&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.81394,
          -33.877347
        ]
      },
      "properties": {
        "title": "Safari Outdoor | Stellenbosch",
        "description": "Safari Outdoor | Stellenbosch",
        "address": "Devon Place Centre, Bottelary Rd & R304 Koelenhof, Stellenbosch, Western Cape, 7605, South Africa",
        "city": "Stellenbosch",
        "state_province": "Western Cape",
        "postal_code": "7605",
        "country": "South Africa",
        "phone": "086 111 4330",
        "website": "https://safarioutdoor.co.za/",
        "email": "info@so.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8236355259067255927&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.818287,
          -34.079694
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Somerset West",
        "description": "Outdoor Warehouse | Somerset West",
        "address": "The Interchange 5 Dynagel Street, Somerset West, Somerset West, Western Cape, 7130, South Africa",
        "city": "Somerset West",
        "state_province": "Western Cape",
        "postal_code": "7130",
        "country": "South Africa",
        "phone": "(021) 851 2304",
        "email": "somersetwest@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17819739298205994586&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.822644,
          -34.082484
        ]
      },
      "properties": {
        "title": "Burgundy Collective",
        "description": "Burgundy Collective",
        "address": "Centenary Drive, Intersection of N2 & R44, Somerset West, Western Cape, 7130, South Africa",
        "city": "Somerset West",
        "state_province": "Western Cape",
        "postal_code": "7130",
        "country": "South Africa",
        "phone": "066 147 8921",
        "website": "http://www.burgundycollective.com/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13398034802079051084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.822911,
          -34.08188
        ]
      },
      "properties": {
        "title": "Yuppiechef | Somerset Mall",
        "description": "Yuppiechef | Somerset Mall",
        "address": "Centenary Drive, Intersection of N2 & R44 Somerset West, Centenary Dr, Somerset West, Somerset West, Western Cape, 7130, South Africa",
        "city": "Somerset West",
        "state_province": "Western Cape",
        "postal_code": "7130",
        "country": "South Africa",
        "phone": "+27212051908",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15486294980288271394&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.848184,
          -33.941213
        ]
      },
      "properties": {
        "title": "Agrimark | Stellenbosch",
        "description": "Agrimark | Stellenbosch",
        "address": "Adam Tas Road, Stellenbosch Central, Stellenbosch, Western Cape, 7600, South Africa",
        "city": "Stellenbosch",
        "state_province": "Western Cape",
        "postal_code": "7600",
        "country": "South Africa",
        "phone": "0218872834",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17933973830021921056&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.876027,
          -33.813411
        ]
      },
      "properties": {
        "title": "Bali Trading | Klapmuts",
        "description": "Bali Trading | Klapmuts",
        "address": "R44, Klapmuts, Klapmuts, Western Cape, 7625, South Africa",
        "city": "Klapmuts",
        "state_province": "Western Cape",
        "postal_code": "7625",
        "country": "South Africa",
        "website": "https://lifestyleatbalitrading.co.za/",
        "email": "jeanine@balitrading.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1856133690782329253&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.958243,
          -33.76539
        ]
      },
      "properties": {
        "title": "The Farm Grocer at Laborie",
        "description": "The Farm Grocer at Laborie",
        "address": "Corner of Taillefer &, Main Rd, Paarl, Western Cape, 7620, South Africa",
        "city": "Paarl",
        "state_province": "Western Cape",
        "postal_code": "7620",
        "country": "South Africa",
        "phone": "021 807 3091",
        "website": "https://laborieestate.co.za/the-farm-grocer/",
        "email": "marketing@laborieestate.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15499435488858975000&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.962518,
          -33.735145
        ]
      },
      "properties": {
        "title": "Franseman",
        "description": "Franseman",
        "address": "281 main road, Dwars-in-die-weg building, Paarl, Western Cape, 7646, South Africa",
        "city": "Paarl",
        "state_province": "Western Cape",
        "postal_code": "7646",
        "country": "South Africa",
        "phone": "021 007 0699",
        "website": "https://franseman.co.za/",
        "email": "info@franseman.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13345233790466412026&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.96345,
          -33.765056
        ]
      },
      "properties": {
        "title": "Boomsticks | Paarl",
        "description": "Boomsticks | Paarl",
        "address": "Cnr of Tabak & 21, 15 Station St, Southern Paar, Paarl, Western Cape, 7646, South Africa",
        "city": "Paarl",
        "state_province": "Western Cape",
        "postal_code": "7646",
        "country": "South Africa",
        "phone": "0210200620",
        "website": "http://boomsticks.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=673669928782997622&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.9657,
          -33.757449
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Paarl",
        "description": "Outdoor Warehouse | Paarl",
        "address": "11919 La Concorde Builders Precint, Cecilia St, Paarl, Paarl, Western Cape, 7624, South Africa",
        "city": "Paarl",
        "state_province": "Western Cape",
        "postal_code": "7624",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2864025027240895612&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.963744,
          -33.761867
        ]
      },
      "properties": {
        "title": "Ryan Boon Specialty Meats",
        "description": "Ryan Boon Specialty Meats",
        "address": "Boulevard road, Paarl, Western Cape, 7646, South Africa",
        "city": "Paarl",
        "state_province": "Western Cape",
        "postal_code": "7646",
        "country": "South Africa",
        "phone": "0218701051",
        "email": "este.carstens@yahoo.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11905327328906238771&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.976132,
          -33.715221
        ]
      },
      "properties": {
        "title": "Agrimark | Paarl",
        "description": "Agrimark | Paarl",
        "address": "Oosboschstraat, Noord-Paarl, Paarl, Western Cape, 7646, South Africa",
        "city": "Paarl",
        "state_province": "Western Cape",
        "postal_code": "7646",
        "country": "South Africa",
        "phone": "021 860 8101",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7227258602736016237&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.984641,
          -33.778443
        ]
      },
      "properties": {
        "title": "Yuppiechef | Parelberg",
        "description": "Yuppiechef | Parelberg",
        "address": "52G3+R82 Pearl Valley Golf Estate and Spa, Cape Town, Western Cape, 7646, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7646",
        "country": "South Africa",
        "phone": "0218910435",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11859992728990842280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.011232,
          -33.638766
        ]
      },
      "properties": {
        "title": "M.Eat Biltong & Deli | Wellington",
        "description": "M.Eat Biltong & Deli | Wellington",
        "address": "M.Eat Biltong & Deli Wellington  60 Church St,  Wellington, Wellington, Western Cape, 7655, South Africa",
        "city": "Wellington",
        "state_province": "Western Cape",
        "postal_code": "7655",
        "country": "South Africa",
        "phone": "+27 21 864 1091",
        "email": "admin@valence.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12983441871233038756&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.012788,
          -32.595911
        ]
      },
      "properties": {
        "title": "Agrimark | Citrusdal",
        "description": "Agrimark | Citrusdal",
        "address": "18 Loopstraat, Citrusdal, Western Cape, 7340, South Africa",
        "city": "Citrusdal",
        "state_province": "Western Cape",
        "postal_code": "7340",
        "country": "South Africa",
        "phone": "0229213535",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=946569610566938490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.034595,
          -34.164111
        ]
      },
      "properties": {
        "title": "Peregrine Farm Stall",
        "description": "Peregrine Farm Stall",
        "address": "N 2 &, R321 Peregrine farm stall, Grabouw, Western Cape, 7160, South Africa",
        "city": "Grabouw",
        "state_province": "Western Cape",
        "postal_code": "7160",
        "country": "South Africa",
        "email": "office@peregrinefarmstall.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17636041852191870576&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.072318,
          -33.883503
        ]
      },
      "properties": {
        "title": "La Motte",
        "description": "La Motte",
        "address": "La Motte Wine Farm, R45 Main Road, Franschhoek Valley, Franschoek, Western Cape, 7690, South Africa",
        "city": "Franschoek",
        "state_province": "Western Cape",
        "postal_code": "7690",
        "country": "South Africa",
        "phone": "0218768000",
        "website": "https://la-motte.com/pages/contact-us",
        "notes": "Donkey Long Tong available at their farm shop.",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3650312155321253752&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.204258,
          -34.415908
        ]
      },
      "properties": {
        "title": "Yuppiechef | Whale Coast",
        "description": "Yuppiechef | Whale Coast",
        "address": "Whale Coast Mall, Main Rd, R43, Sandbaai, Hermanus, Western Cape, 7201, South Africa",
        "city": "Hermanus",
        "state_province": "Western Cape",
        "postal_code": "7201",
        "country": "South Africa",
        "phone": "0280500116",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14072035785984043761&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.20388,
          -34.416367
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Hermanus",
        "description": "Outdoor Warehouse | Hermanus",
        "address": "Shop L15, Whale Coast Village Mall, Main Road, Hermanus, Hermanus, Western Cape, 7200, South Africa",
        "city": "Hermanus",
        "state_province": "Western Cape",
        "postal_code": "7200",
        "country": "South Africa",
        "phone": "(028) 753 0580",
        "email": "hermanus@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9425697679229406459&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.432112,
          -33.632889
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Worcester",
        "description": "Outdoor Warehouse | Worcester",
        "address": "13 Mountain Mill Drive, Shop 2, Mill House Lifestyle Centre, Hospital Hill, Worcester, Worcester, Western Cape, 6850, South Africa",
        "city": "Worcester",
        "state_province": "Western Cape",
        "postal_code": "6850",
        "country": "South Africa",
        "phone": "023 753 0330",
        "email": "worcester@odw.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16719368046287833475&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.446025,
          -33.643398
        ]
      },
      "properties": {
        "title": "Quénets Hunting & Fishing",
        "description": "Quénets Hunting & Fishing",
        "address": "Shop 4/5, Q-Square, 72 High St, Worcester Central, Worcester, Western Cape, 6850, South Africa",
        "city": "Worcester",
        "state_province": "Western Cape",
        "postal_code": "6850",
        "country": "South Africa",
        "phone": "023 347 7188",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11547007782526044240&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.881192,
          -33.81066
        ]
      },
      "properties": {
        "title": "Wildman Hunting & Outdoor",
        "description": "Wildman Hunting & Outdoor",
        "address": "8 Voortrekker Avenue, Robertson, Western Cape, 6705, South Africa",
        "city": "Robertson",
        "state_province": "Western Cape",
        "postal_code": "6705",
        "country": "South Africa",
        "phone": "023 036 0000",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12200368498097349340&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          19.885323,
          -33.811535
        ]
      },
      "properties": {
        "title": "Agrimark | Robertson",
        "description": "Agrimark | Robertson",
        "address": "Agrimark Adderleystraat, Robertson, Western Cape, 6705, South Africa",
        "city": "Robertson",
        "state_province": "Western Cape",
        "postal_code": "6705",
        "country": "South Africa",
        "phone": "0236261900",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=782611328904295395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          20.040714,
          -34.794221
        ]
      },
      "properties": {
        "title": "M. Eat Biltong & Deli | Struisbaai",
        "description": "M. Eat Biltong & Deli | Struisbaai",
        "address": "Shop 1, Mall, Industria Rd, Struisbaai, Western Cape, 7285, South Africa",
        "city": "Struisbaai",
        "state_province": "Western Cape",
        "postal_code": "7285",
        "country": "South Africa",
        "phone": "072 126 4928",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16475953832683784053&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          20.452046,
          -34.018934
        ]
      },
      "properties": {
        "title": "Biltong Boys and Coffee Bar",
        "description": "Biltong Boys and Coffee Bar",
        "address": "Wagenweg Boutique Market, 23 Swellengrebel St, Swellendam, Western Cape, 6740, South Africa",
        "city": "Swellendam",
        "state_province": "Western Cape",
        "postal_code": "6740",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4855712411058583753&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.244037,
          -28.458043
        ]
      },
      "properties": {
        "title": "My 4X4 Fitment",
        "description": "My 4X4 Fitment",
        "address": "43 Mark Street, Upington, Northern Cape, 8800, South Africa",
        "city": "Upington",
        "state_province": "Northern Cape",
        "postal_code": "8800",
        "country": "South Africa",
        "phone": "054 050 1388",
        "website": "https://beekman.co.za",
        "email": "sales@my4x4fitment.co.za",
        "regions": [
          "Northern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8644556481092837013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.247203,
          -28.452107
        ]
      },
      "properties": {
        "title": "Agrimark | Upington",
        "description": "Agrimark | Upington",
        "address": "20 Anton Lubowski Road, Upington, Northern Cape, 8801, South Africa",
        "city": "Upington",
        "state_province": "Northern Cape",
        "postal_code": "8801",
        "country": "South Africa",
        "phone": "0543389000",
        "regions": [
          "Northern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12245880439063257333&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.249025,
          -28.453567
        ]
      },
      "properties": {
        "title": "Walker's Midas | Upington",
        "description": "Walker's Midas | Upington",
        "address": "Kooperasie St, 1, Upington, Northern Cape, 8800, South Africa",
        "city": "Upington",
        "state_province": "Northern Cape",
        "postal_code": "8800",
        "country": "South Africa",
        "phone": "054 337 5200",
        "website": "https://www.walkergroup.co.za/locations/walkers-midas/",
        "regions": [
          "Northern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7065462115517297333&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.255236,
          -34.111454
        ]
      },
      "properties": {
        "title": "Bali Trading | Riversdale",
        "description": "Bali Trading | Riversdale",
        "address": "N2 National Rd, Riversdale, Riversdale, Western Cape, 6670, South Africa",
        "city": "Riversdale",
        "state_province": "Western Cape",
        "postal_code": "6670",
        "country": "South Africa",
        "phone": "083 266 8497",
        "website": "http://www.lifestyleatbalitrading.co.za/",
        "email": "jeanine@balitrading.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14973244107939473459&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.258864,
          -34.093315
        ]
      },
      "properties": {
        "title": "Pet, Pool & Home | Riversdale",
        "description": "Pet, Pool & Home | Riversdale",
        "address": "30 President CR Swart St, Riversdale, Western Cape, 6670, South Africa",
        "city": "Riversdale",
        "state_province": "Western Cape",
        "postal_code": "6670",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16095556303859523185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.40493,
          -34.370358
        ]
      },
      "properties": {
        "title": "Bali Trading | Still Bay West",
        "description": "Bali Trading | Still Bay West",
        "address": "6-2 Voortrekker Street, Still Bay West, Still Bay, Western Cape, 6674, South Africa",
        "city": "Still Bay",
        "state_province": "Western Cape",
        "postal_code": "6674",
        "country": "South Africa",
        "phone": "028 754 2072",
        "website": "https://www.lifestyleatbalitrading.co.za/",
        "email": "jeanine@balitrading.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3514152835634282471&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.417168,
          -34.364489
        ]
      },
      "properties": {
        "title": "Bali Trading | Still Bay East",
        "description": "Bali Trading | Still Bay East",
        "address": "Van Wyk St, Still Bay East, Still Bay, Western Cape, 6674, South Africa",
        "city": "Still Bay",
        "state_province": "Western Cape",
        "postal_code": "6674",
        "country": "South Africa",
        "phone": "028 754 1266",
        "website": "https://www.lifestyleatbalitrading.co.za/",
        "email": "jeanine@balitrading.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3529426274634179183&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.903602,
          -34.334323
        ]
      },
      "properties": {
        "title": "Johnson's Post",
        "description": "Johnson's Post",
        "address": "Kanon Private Reserve, Mossel Bay, Mossel Bay, Western Cape, 6506, South Africa",
        "city": "Mossel Bay",
        "state_province": "Western Cape",
        "postal_code": "6506",
        "country": "South Africa",
        "email": "danaarnoldi11@gmail.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11362177471571552038&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.107355,
          -33.388537
        ]
      },
      "properties": {
        "title": "Swartberg Experience/Kobus se Gat",
        "description": "Swartberg Experience/Kobus se Gat",
        "address": "170 st John Street, Oudtshoorn, Western Cape, 6625, South Africa",
        "city": "Oudtshoorn",
        "state_province": "Western Cape",
        "postal_code": "6625",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9978319788790377490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.263568,
          -33.624129
        ]
      },
      "properties": {
        "title": "Karoo Lusern Slaghuis",
        "description": "Karoo Lusern Slaghuis",
        "address": "Karoo Lusern Plaas, Roodeheuwel, Oudtshoorn, Western Cape, 6620, South Africa",
        "city": "Oudtshoorn",
        "state_province": "Western Cape",
        "postal_code": "6620",
        "country": "South Africa",
        "phone": "0442720355",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13222170551714555695&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.387952,
          -34.007682
        ]
      },
      "properties": {
        "title": "Elvis Brew",
        "description": "Elvis Brew",
        "address": "Across George Airport, Next to Bargain Nursery, R404, George, Western Cape, 6530, South Africa",
        "city": "George",
        "state_province": "Western Cape",
        "postal_code": "6530",
        "country": "South Africa",
        "phone": "0615485155",
        "website": "http://www.elvisbrew.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10407672204545403522&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.432736,
          -33.950947
        ]
      },
      "properties": {
        "title": "Pharma Warehouse",
        "description": "Pharma Warehouse",
        "address": "Shop 7B Heather Park Centre, CNR of Pine and Witfontein Rd, George, Western Cape, 6530, South Africa",
        "city": "George",
        "state_province": "Western Cape",
        "postal_code": "6530",
        "country": "South Africa",
        "phone": "044 870 7181",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14804490966197776174&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.441023,
          -33.995909
        ]
      },
      "properties": {
        "title": "Kloppers | George",
        "description": "Kloppers | George",
        "address": "Pioneer Street Pacaltsdorp, Industria, George, Western Cape, 6530, South Africa",
        "city": "George",
        "state_province": "Western Cape",
        "postal_code": "6530",
        "country": "South Africa",
        "phone": "0448023900",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5829077633779185667&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.479672,
          -33.96477
        ]
      },
      "properties": {
        "title": "George Gas",
        "description": "George Gas",
        "address": "43 Knysna Weg, George, Western Cape, 6530, South Africa",
        "city": "George",
        "state_province": "Western Cape",
        "postal_code": "6530",
        "country": "South Africa",
        "phone": "044 871 2636",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4356052804881768963&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.447283,
          -33.971385
        ]
      },
      "properties": {
        "title": "PET Pool & Fire | George",
        "gmaps_uri": "https://maps.google.com/?cid=2603207426002841175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "PET Pool & Fire | George",
        "address": "74 Knysna Road, Eastern Ext, George, Western Cape, 6529, South Africa",
        "city": "George",
        "state_province": "Western Cape",
        "postal_code": "6529",
        "country": "South Africa",
        "phone": "087 657 1051",
        "website": "https://www.petandpool.co.za",
        "email": "york@petandpool.co.za",
        "regions": [
          "Western Cape"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.763795,
          -28.7660496
        ]
      },
      "properties": {
        "title": "Overland Clothing",
        "gmaps_uri": "",
        "description": "Overland Clothing",
        "address": "Shop 88, Diamond Pavillion Mall, Kimberley, Northern Cape, 8301 8301, South Africa",
        "city": "Kimberley",
        "state_province": "Northern Cape",
        "postal_code": "8301",
        "country": "South Africa",
        "website": "https://overlandsa.co.za",
        "email": "kimberley@overlandsa.co.za",
        "regions": [
          "Northern Cape"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.89903,
          -34.030594
        ]
      },
      "properties": {
        "title": "Inhouse | Jeffreys Bay",
        "gmaps_uri": "https://maps.google.com/?cid=17928340103793987363&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "Inhouse | Jeffreys Bay",
        "address": "Fountains Mall, Fountains Estate, Jeffreys Bay, Eastern Cape, 6330, South Africa",
        "city": "Jeffreys Bay",
        "state_province": "Eastern Cape",
        "postal_code": "6330",
        "country": "South Africa",
        "phone": "067 302 5333",
        "website": "https://thekitchenshop.co.za/",
        "email": "inhousejb@mweb.co.za",
        "regions": [
          "Eastern Cape"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.866719,
          -31.89465
        ]
      },
      "properties": {
        "title": "Langside Meat",
        "gmaps_uri": "https://maps.google.com/?cid=13175234457895248173&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "Langside Meat",
        "address": "130 Cathcart Street, Likka Land, Queenstown, Eastern Cape, 5319, South Africa",
        "city": "Queenstown",
        "state_province": "Eastern Cape",
        "postal_code": "5319",
        "country": "South Africa",
        "phone": "0824652610",
        "regions": [
          "Eastern Cape"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.006424,
          -26.018879
        ]
      },
      "properties": {
        "title": "Yuppiechef | Fourways",
        "gmaps_uri": "https://maps.google.com/?cid=6101929079397152051&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "Yuppiechef | Fourways",
        "address": "Shop number G84-85, Fourways Mall, Fourways, Johannesburg, Gauteng, 2068, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2068",
        "country": "South Africa",
        "phone": "010 1402994",
        "regions": [
          "Gauteng"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.161031,
          -25.841523
        ]
      },
      "properties": {
        "title": "Saxby Superspar",
        "gmaps_uri": "https://maps.google.com/?cid=7137988508538389570&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "Saxby Superspar",
        "address": "1033 Saxby Avenue, Eldoraigne Ext 1, Eldoraigne Ext 1, Centurian, Gauteng, 0157, South Africa",
        "city": "Centurian",
        "state_province": "Gauteng",
        "postal_code": "0157",
        "country": "South Africa",
        "phone": "0126543901",
        "website": "https://www.spar.co.za/home/store-view/superspar-saxby-gauteng",
        "email": "saxby1@retail.spar.co.za",
        "regions": [
          "Gauteng"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.246823,
          -25.819955
        ]
      },
      "properties": {
        "title": "Yuppiechef | Castle Gate",
        "gmaps_uri": "https://maps.app.goo.gl/SJUZWH7AVV6UXN85A",
        "description": "Yuppiechef | Castle Gate",
        "address": "Shop number 21, 478 Koedoesnek Ave, Waterkloof Ridge, Pretoria, Gauteng, 0181, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0181",
        "country": "South Africa",
        "phone": "+27121410268",
        "regions": [
          "Gauteng"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.135164,
          -29.457973
        ]
      },
      "properties": {
        "title": "The Pantry",
        "gmaps_uri": "https://maps.google.com/?cid=5813240774792177023&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "The Pantry",
        "address": "Piggly Wiggly Centre, Lidgetton, R103, Pietermaritzburg, KwaZulu-Natal, 3200, South Africa",
        "city": "Pietermaritzburg",
        "state_province": "KwaZulu-Natal",
        "postal_code": "3200",
        "country": "South Africa",
        "phone": "078 604 8364",
        "email": "mrqgeo001@gmail.com",
        "regions": [
          "KwaZulu-Natal"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.300782,
          -29.561768
        ]
      },
      "properties": {
        "title": "Good Living Home",
        "gmaps_uri": "",
        "description": "Good Living Home",
        "address": "Shop 5, The Hilton Quarry Centre, 57 Hilton Ave Hilton, Pietermaritzburg, Pietermaritzburg, KwaZulu-Natal, 3245, South Africa",
        "city": "Pietermaritzburg",
        "state_province": "KwaZulu-Natal",
        "postal_code": "3245",
        "country": "South Africa",
        "phone": "072 012 4566 / 0333431210",
        "email": "hello@goodlivinghome.co.za",
        "regions": [
          "KwaZulu-Natal"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.203668,
          -29.526012
        ]
      },
      "properties": {
        "title": "Wozza Meat Company",
        "gmaps_uri": "https://maps.google.com/?cid=11380507585538907710&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "Wozza Meat Company",
        "address": "Ballito Junction, 4399 Leonora Dr, Ballito, KwaZulu-Natal, 4420, South Africa",
        "city": "Ballito",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4420",
        "country": "South Africa",
        "regions": [
          "KwaZulu-Natal"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.499042,
          -33.984139
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | George",
        "description": "Outdoor Warehouse | George",
        "address": "Eden Meander Lifestyle Centre, Knysna Rd, George, Western Cape, 6529, South Africa",
        "city": "George",
        "state_province": "Western Cape",
        "postal_code": "6529",
        "country": "South Africa",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4480456922044725259&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          22.58184,
          -32.342161
        ]
      },
      "properties": {
        "title": "Nuveld Motors",
        "description": "Nuveld Motors",
        "address": "3 Donkin Street, Beaufort West, Western Cape, 6970, South Africa",
        "city": "Beaufort West",
        "state_province": "Western Cape",
        "postal_code": "6970",
        "country": "South Africa",
        "phone": "023 414 4117",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13553431386440101200&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          23.015241,
          -31.984913
        ]
      },
      "properties": {
        "title": "Whistling Bridge Cafe",
        "description": "Whistling Bridge Cafe",
        "address": "N1 Krom River, Three Sisters, Beaufort West, Western Cape, 6970, South Africa",
        "city": "Beaufort West",
        "state_province": "Western Cape",
        "postal_code": "6970",
        "country": "South Africa",
        "phone": "0842068536",
        "email": "whistlingbridge@gmail.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9072224969617936692&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          23.043041,
          -34.035373
        ]
      },
      "properties": {
        "title": "Kloppers | Knysna",
        "description": "Kloppers | Knysna",
        "address": "54 Main Rd, Kysna, Western Cape, 6571, South Africa",
        "city": "Kysna",
        "state_province": "Western Cape",
        "postal_code": "6571",
        "country": "South Africa",
        "phone": "044 302 7800",
        "website": "https://kloppers.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13078320120567212937&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          23.04946,
          -34.040171
        ]
      },
      "properties": {
        "title": "Metelerkamps",
        "description": "Metelerkamps",
        "address": "3 union Street, Off Waterfront Drive, Knysna, Western Cape, 6571, South Africa",
        "city": "Knysna",
        "state_province": "Western Cape",
        "postal_code": "6571",
        "country": "South Africa",
        "phone": "044 382 0274",
        "website": "https://metelerkamps.co.za/?srsltid=AfmBOoo2yxMqvI1leRveFGEYphVPR_I4ABXqO3JnJkj2tXnlwbNnPfN7",
        "email": "avril@Metelerkamps.co.za",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4796875838238542456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          23.369721,
          -34.041916
        ]
      },
      "properties": {
        "title": "The Biltong Boutique",
        "description": "The Biltong Boutique",
        "address": "Shop 16, Market Square, Plettenberg Bay, Western Cape, 6600, South Africa",
        "city": "Plettenberg Bay",
        "state_province": "Western Cape",
        "postal_code": "6600",
        "country": "South Africa",
        "phone": "0716581919",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4041817194466835237&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.533335,
          -32.247925
        ]
      },
      "properties": {
        "title": "Ouma's Country Store",
        "description": "Ouma's Country Store",
        "address": "38 Noord Street, Graaff-Reinet, Eastern Cape, 6280, South Africa",
        "city": "Graaff-Reinet",
        "state_province": "Eastern Cape",
        "postal_code": "6280",
        "country": "South Africa",
        "phone": "0835382865",
        "regions": [
          "Eastern Cape"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.759226,
          -28.766806
        ]
      },
      "properties": {
        "title": "Louise Rame Framing",
        "description": "Louise Rame Framing",
        "address": "28 Mac Dougall St, Monument Heights, Kimberley, Northern Cape, 8301, South Africa",
        "city": "Kimberley",
        "state_province": "Northern Cape",
        "postal_code": "8301",
        "country": "South Africa",
        "phone": "0538323421",
        "email": "rudi@louiserame.co.za",
        "regions": [
          "Northern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6833440582117660927&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.827301,
          -34.161226
        ]
      },
      "properties": {
        "title": "Inhouse | St Francis Bay",
        "description": "Inhouse | St Francis Bay",
        "address": "St Francis Dr, St Francis Bay, Eastern Cape, 6312, South Africa",
        "city": "St Francis Bay",
        "state_province": "Eastern Cape",
        "postal_code": "6312",
        "country": "South Africa",
        "phone": "0422940872",
        "website": "https://thekitchenshop.co.za/",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6891974952979440261&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.91762,
          -34.04543
        ]
      },
      "properties": {
        "title": "PET Pool & Fire | Jeffreys Bay",
        "description": "PET Pool & Fire | Jeffreys Bay",
        "address": "Equinox Mall, St Francis St, Jeffreys Bay, Eastern Cape, 6330, South Africa",
        "city": "Jeffreys Bay",
        "state_province": "Eastern Cape",
        "postal_code": "6330",
        "country": "South Africa",
        "phone": "010 010 7087",
        "website": "https://www.petandpool.co.za",
        "email": "jbay@petandpool.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16194210103473393847&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          24.922193,
          -34.056541
        ]
      },
      "properties": {
        "title": "Haas Jou",
        "description": "Haas Jou",
        "address": "Jbay Surf Village, 4 Da Gama Rd, Jeffreys Bay, Eastern Cape, 6330, South Africa",
        "city": "Jeffreys Bay",
        "state_province": "Eastern Cape",
        "postal_code": "6330",
        "country": "South Africa",
        "phone": "078 463 3631",
        "email": "haasjou@gmail.com",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6804338948795232718&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          21.100798,
          -28.602535
        ]
      },
      "properties": {
        "title": "Bezalel Wine & Brandy Estate",
        "description": "Bezalel Wine & Brandy Estate",
        "address": "N14, Dyasons Klip Settlement, Upington, Northern Cape, 8805, South Africa",
        "city": "Upington",
        "state_province": "Northern Cape",
        "postal_code": "8805",
        "country": "South Africa",
        "regions": [
          "Northern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18400556150555574038&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.443495,
          -33.397659
        ]
      },
      "properties": {
        "title": "Nadora Coffee Shop & Gifts",
        "description": "Nadora Coffee Shop & Gifts",
        "address": "15 Middle Street, Kirkwood, Eastern Cape, 6120, South Africa",
        "city": "Kirkwood",
        "state_province": "Eastern Cape",
        "postal_code": "6120",
        "country": "South Africa",
        "phone": "066 018 8360",
        "email": "Admin@nadoracoffee.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1144906839124234611&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.58509,
          -26.613094
        ]
      },
      "properties": {
        "title": "Halfpad Handelshuis",
        "description": "Halfpad Handelshuis",
        "address": "N14 Barberspan, Delareyville, North West, 2770, South Africa",
        "city": "Delareyville",
        "state_province": "North West",
        "postal_code": "2770",
        "country": "South Africa",
        "phone": "0835661002",
        "regions": [
          "North West"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.553247,
          -33.977417
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Gqeberha",
        "description": "Outdoor Warehouse | Gqeberha",
        "address": "Cnr William Moffett Expy & Oak Rd Shop 1, Martime Retail Park, Overbaakens, Gqeberha, Eastern Cape, 6001, South Africa",
        "city": "Gqeberha",
        "state_province": "Eastern Cape",
        "postal_code": "6001",
        "country": "South Africa",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1806189674108117961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.55437,
          -33.979286
        ]
      },
      "properties": {
        "title": "Bidfood | Gqeberha",
        "description": "Bidfood | Gqeberha",
        "address": "12, 18, 16th Ave, Walmer, Gqeberha, Eastern Cape, 6070, South Africa",
        "city": "Gqeberha",
        "state_province": "Eastern Cape",
        "postal_code": "6070",
        "country": "South Africa",
        "phone": "041 486 1900",
        "website": "https://www.bidfood.co.za/branches/gqeberha.php",
        "email": "Jazmaine.Botha@bidfood.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7374379064087786211&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.55438,
          -33.984349
        ]
      },
      "properties": {
        "title": "Kloppers | Gqeberha",
        "description": "Kloppers | Gqeberha",
        "address": "17th Avenue, Walmer, Gqeberha, Eastern Cape, 6070, South Africa",
        "city": "Gqeberha",
        "state_province": "Eastern Cape",
        "postal_code": "6070",
        "country": "South Africa",
        "phone": "041 394 2900",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2731527182481741149&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.554213,
          -33.969564
        ]
      },
      "properties": {
        "title": "PET Pool & Fire | Gqeberha",
        "description": "PET Pool & Fire | Gqeberha",
        "address": "Unit A, Fairview Retail Park, Cnr William Moffett & Willow roads, Walmer Heights, Gqeberha, Eastern Cape, 6070, South Africa",
        "city": "Gqeberha",
        "state_province": "Eastern Cape",
        "postal_code": "6070",
        "country": "South Africa",
        "phone": "041 368 1908",
        "website": "https://www.petandpool.co.za",
        "email": "portelizabeth@petandpool.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3715552329130323954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.59024,
          -32.7248161
        ]
      },
      "properties": {
        "title": "Boomsticks | Somerset East",
        "description": "Boomsticks | Somerset East",
        "address": "16 Charles Street, Somerset-East, KwaNojoli, Eastern Cape, 5850, South Africa",
        "city": "KwaNojoli",
        "state_province": "Eastern Cape",
        "postal_code": "5850",
        "country": "South Africa",
        "phone": "076 580 2391",
        "website": "https://boomsticks.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9462492473721344837&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          25.615092,
          -32.165485
        ]
      },
      "properties": {
        "title": "JSM 4X4",
        "description": "JSM 4X4",
        "address": "66 Beeren Street, Cradock, Eastern Cape, 5880, South Africa",
        "city": "Cradock",
        "state_province": "Eastern Cape",
        "postal_code": "5880",
        "country": "South Africa",
        "phone": "071 890 4493",
        "website": "https://jsm4x4.co.za",
        "email": "darran@jsm4x4.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6937611902215412671&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.136293,
          -29.066877
        ]
      },
      "properties": {
        "title": "Safari Country | Bloemfontein",
        "description": "Safari Country | Bloemfontein",
        "address": "Corner Abrahamskraal & Dealesville, R64, Bloemfontein, Free State, 9335, South Africa",
        "city": "Bloemfontein",
        "state_province": "Free State",
        "postal_code": "9335",
        "country": "South Africa",
        "phone": "086 110 0019",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6893513841681075558&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.18902,
          -29.156208
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Bloemfontein",
        "description": "Outdoor Warehouse | Bloemfontein",
        "address": "Cnr Curie Ave & Vereeniging Dr, Shop B3, Game Value Centre, Fleurdal, Bloemfontein, Free State, Bloemfontein, Free State, 9301, South Africa",
        "city": "Bloemfontein",
        "state_province": "Free State",
        "postal_code": "9301",
        "country": "South Africa",
        "phone": "051 421 0087",
        "email": "bloemfontein@odw.co.za",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13670443658759192521&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.196163,
          -29.121665
        ]
      },
      "properties": {
        "title": "Boet en Sus",
        "description": "Boet en Sus",
        "address": "101 Victoria Rd, Park West, Bloemfontein, Free State, 9301, South Africa",
        "city": "Bloemfontein",
        "state_province": "Free State",
        "postal_code": "9301",
        "country": "South Africa",
        "phone": "071 877 5949",
        "gmaps_uri": "https://maps.google.com/?cid=17844666266257285152&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.210579,
          -29.113663
        ]
      },
      "properties": {
        "title": "Kloppers | Bloemfontein",
        "description": "Kloppers | Bloemfontein",
        "address": "Loch Logan Waterfront, 105/7 Henry St, Willows, Bloemfontein, Free State, 9300, South Africa",
        "city": "Bloemfontein",
        "state_province": "Free State",
        "postal_code": "9300",
        "country": "South Africa",
        "phone": "0514005500",
        "website": "https://kloppers.co.za/",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10885946419781596483&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.214017,
          -29.081627
        ]
      },
      "properties": {
        "title": "Kraal Family Butchery",
        "description": "Kraal Family Butchery",
        "address": "29 Toon van der heever street, Bloemfontein, Free State, 9301, South Africa",
        "city": "Bloemfontein",
        "state_province": "Free State",
        "postal_code": "9301",
        "country": "South Africa",
        "phone": "084 909 9900",
        "email": "kraalmeats@gmail.com",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17988536145316408852&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.233622,
          -29.069958
        ]
      },
      "properties": {
        "title": "Yuppiechef | Northridge Mall",
        "description": "Yuppiechef | Northridge Mall",
        "address": "Northridge Mall, Eeufees Road, Bayswater, Bloemfontein, Free State, 9301, South Africa",
        "city": "Bloemfontein",
        "state_province": "Free State",
        "postal_code": "9301",
        "country": "South Africa",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7446859835407332363&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          26.732571,
          -27.986842
        ]
      },
      "properties": {
        "title": "Overland Goldfields",
        "description": "Overland Goldfields",
        "address": "Shop 5, Welkom Park 1 Petrus Bosch street Jan Cillierspark, Welkom, Free State, 9459, South Africa",
        "city": "Welkom",
        "state_province": "Free State",
        "postal_code": "9459",
        "country": "South Africa",
        "phone": "057 050 1143",
        "email": "admin@overlandgf.co.za",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17492963315167100407&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.10373,
          -26.70272
        ]
      },
      "properties": {
        "title": "Homestead Butchery",
        "description": "Homestead Butchery",
        "address": "1 Palmiet Street, Potchefstroom, North West, 2520, South Africa",
        "city": "Potchefstroom",
        "state_province": "North West",
        "postal_code": "2520",
        "country": "South Africa",
        "phone": "018 065 0560",
        "email": "orders@homesteadbutchery.co.za",
        "regions": [
          "North West"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10866253308600033347&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.103529,
          -26.667254
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Potchefstroom",
        "description": "Outdoor Warehouse | Potchefstroom",
        "address": "Vyfhoek Shopping Centre, Cnr R501 and Kremetart Street, Potchefstroom, North West Province, Potchefstroom, North West, 2531, South Africa",
        "city": "Potchefstroom",
        "state_province": "North West",
        "postal_code": "2531",
        "country": "South Africa",
        "phone": "018 753 0011",
        "email": "potchefstroom@odw.co.za",
        "regions": [
          "North West"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11598275671886441166&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.243297,
          -25.664456
        ]
      },
      "properties": {
        "title": "The Gas Boys",
        "description": "The Gas Boys",
        "address": "108 President Mbeki Drive, Rustenburg, Rustenburg, North West, 2999, South Africa",
        "city": "Rustenburg",
        "state_province": "North West",
        "postal_code": "2999",
        "country": "South Africa",
        "phone": "014 592 8530",
        "website": "https://gasboysrustenburg.co.za/",
        "email": "sales@gasboysrustenburg.co.za",
        "regions": [
          "North West"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11120899721312768368&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.250774,
          -25.702766
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Rustenburg",
        "description": "Outdoor Warehouse | Rustenburg",
        "address": "Platinum Square Shopping Centre, 74 Gareth Roberts Avenue, Cashan, Rustenburg, Rustenburg, North West, 0299, South Africa",
        "city": "Rustenburg",
        "state_province": "North West",
        "postal_code": "0299",
        "country": "South Africa",
        "phone": "014 537 2621",
        "email": "admin-rustenburg@odw.co.za",
        "regions": [
          "North West"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13650762192335582001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.447217,
          -26.906881
        ]
      },
      "properties": {
        "title": "Miru Living",
        "description": "Miru Living",
        "address": "EnStyle Building, 100 Bree St, Parys, Free State, 9585, South Africa",
        "city": "Parys",
        "state_province": "Free State",
        "postal_code": "9585",
        "country": "South Africa",
        "phone": "082 778 3632",
        "email": "marietjie@miruliving.co.za",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8669460128006971348&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.781942,
          -25.66001
        ]
      },
      "properties": {
        "title": "Impala Vleis Brits",
        "description": "Impala Vleis Brits",
        "address": "R512, Brits, North West, 0250, South Africa",
        "city": "Brits",
        "state_province": "North West",
        "postal_code": "0250",
        "country": "South Africa",
        "phone": "0122526056",
        "website": "https://impalavleis.co.za/",
        "regions": [
          "North West"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6919120560013771258&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.838129,
          -26.061975
        ]
      },
      "properties": {
        "title": "Safari Outdoor | Cradlestone",
        "description": "Safari Outdoor | Cradlestone",
        "address": "Cradlestone Mall, Shop U49A, Furrow Rd, Krugersdorp, Gauteng, 0173, South Africa",
        "city": "Krugersdorp",
        "state_province": "Gauteng",
        "postal_code": "0173",
        "country": "South Africa",
        "phone": "086 111 4324",
        "website": "https://safarioutdoor.co.za/",
        "email": "info@so.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6587143774744693835&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.838129,
          -26.061975
        ]
      },
      "properties": {
        "title": "Safari Outdoor | Krugersdorp",
        "description": "Safari Outdoor | Krugersdorp",
        "address": "Cradlestone Mall, Shop U49A, Furrow Rd, Krugersdorp, Gauteng, 0173, South Africa",
        "city": "Krugersdorp",
        "state_province": "Gauteng",
        "postal_code": "0173",
        "country": "South Africa",
        "phone": "086 111 4324",
        "website": "https://safarioutdoor.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6587143774744693835&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.844164,
          -26.127161
        ]
      },
      "properties": {
        "title": "Braai Chom",
        "description": "Braai Chom",
        "address": "36 Ontdekkers Rd, Princess, Roodepoort, Gauteng, 1724, South Africa",
        "city": "Roodepoort",
        "state_province": "Gauteng",
        "postal_code": "1724",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9334473323214286840&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.14554,
          -26.117908
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Modderfontein",
        "description": "Outdoor Warehouse | Modderfontein",
        "address": "Blackrock St, Shop 70 & 71, Stoneridge Centre, Modderfontein, Lethabong, Johannesburg East, Johannesburg, Gauteng, 1609, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "1609",
        "country": "South Africa",
        "phone": "011 452 1957",
        "email": "admin-modderfontein@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14193065367765136261&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.884069,
          -26.699682
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Vanderbijlpark",
        "description": "Outdoor Warehouse | Vanderbijlpark",
        "address": "Corner Playfair Boulevard &, Ascot On Vaal Rd,Shop 125, President Square Vaal, Vaal, Vereeniging, Vanderbijlpark, Free State, 1911, South Africa",
        "city": "Vanderbijlpark",
        "state_province": "Free State",
        "postal_code": "1911",
        "country": "South Africa",
        "phone": "016 985 5116",
        "email": "vanderbijl@odw.co.za",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5933302653558334365&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.897029,
          -26.116704
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Strubensvalley",
        "description": "Outdoor Warehouse | Strubensvalley",
        "address": "Retail Crossing, Cnr Hendrik Potgieter &, Nic Diederichs Rd, Wilgeheuwel, Roodepoort, Gauteng, 1724, South Africa",
        "city": "Roodepoort",
        "state_province": "Gauteng",
        "postal_code": "1724",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=321045660402179232&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.927902,
          -26.095761
        ]
      },
      "properties": {
        "title": "Delft Butchery and Deli",
        "description": "Delft Butchery and Deli",
        "address": "Scott Avenue & Christian De Wet Rd, Randpark Ridge, Randburg, Gauteng, 2195, South Africa",
        "city": "Randburg",
        "state_province": "Gauteng",
        "postal_code": "2195",
        "country": "South Africa",
        "website": "https://www.delftbutchery.co.za",
        "email": "info@delftbutchery.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15202927621890175220&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.929514,
          -32.951555
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | East London",
        "description": "Outdoor Warehouse | East London",
        "address": "Bonza Bay Rd, Shop 6B, Beacon Bay Crossing, Quenera North, East London, Eastern Cape, East London, Eastern Cape, 5201, South Africa",
        "city": "East London",
        "state_province": "Eastern Cape",
        "postal_code": "5201",
        "country": "South Africa",
        "phone": "(043) 748-3688",
        "email": "eastlondon@odw.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12611719142558937865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.929496,
          -26.680424
        ]
      },
      "properties": {
        "title": "Vaalgas",
        "description": "Vaalgas",
        "address": "19 Victoria Ave, Vereeniging, Gauteng, 1930, South Africa",
        "city": "Vereeniging",
        "state_province": "Gauteng",
        "postal_code": "1930",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2773616894782410718&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.940169,
          -32.967265
        ]
      },
      "properties": {
        "title": "SUPERSPAR | Spargs Beacon Bay",
        "description": "SUPERSPAR | Spargs Beacon Bay",
        "address": "2 Major Square Rd, Beacon Bay North, East London, Eastern Cape, 5205, South Africa",
        "city": "East London",
        "state_province": "Eastern Cape",
        "postal_code": "5205",
        "country": "South Africa",
        "phone": "0437117700",
        "website": "https://spargsmall.co.za/spargs-superspar/",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2568614149537249062&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.942838,
          -26.096033
        ]
      },
      "properties": {
        "title": "SA Premier Fires",
        "description": "SA Premier Fires",
        "address": "Lifestyle Garden Centre Cnr Beyers Naude & Ysterhout Road Randpark Ridge, Johannesburg, Gauteng, 2156, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2156",
        "country": "South Africa",
        "phone": "010 020 5994",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5619567893243270957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.971073,
          -26.661818
        ]
      },
      "properties": {
        "title": "Outdoorsman",
        "description": "Outdoorsman",
        "address": "Shop R5, RiverSquare Shopping Centre, Nile Drive, Three Rivers, Vereeniging, Gauteng, 1939, South Africa",
        "city": "Vereeniging",
        "state_province": "Gauteng",
        "postal_code": "1939",
        "country": "South Africa",
        "phone": "016 423 5370",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2153539324894531058&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.966532,
          -26.658998
        ]
      },
      "properties": {
        "title": "Mica | Three Rivers",
        "description": "Mica | Three Rivers",
        "address": "The Village Centre, Service Rd, Three Rivers, Vereeniging, Gauteng, 1929, South Africa",
        "city": "Vereeniging",
        "state_province": "Gauteng",
        "postal_code": "1929",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11499892244841205685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.974816,
          -26.076493
        ]
      },
      "properties": {
        "title": "4x4 Megaworld | Strijdom Park",
        "description": "4x4 Megaworld | Strijdom Park",
        "address": "Unit C1 Malibongwe Exchange. CNR Tungsten Rd &, Malibongwe Dr, Strydompark, Randburg, Gauteng, 2169, South Africa",
        "city": "Randburg",
        "state_province": "Gauteng",
        "postal_code": "2169",
        "country": "South Africa",
        "phone": "0117911212",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5847465009040666954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.995179,
          -26.023284
        ]
      },
      "properties": {
        "title": "Braai & Fireplace Man",
        "description": "Braai & Fireplace Man",
        "address": "Kingfisher Drive, Fourways, Johannesburg, Gauteng, 2055, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2055",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8265318503200098859&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.000963,
          -26.653025
        ]
      },
      "properties": {
        "title": "Four Way KwikSpar",
        "description": "Four Way KwikSpar",
        "address": "General Hertzog Rd, Three Rivers, Vereeniging, Gauteng, 1941, South Africa",
        "city": "Vereeniging",
        "state_province": "Gauteng",
        "postal_code": "1941",
        "country": "South Africa",
        "phone": "0164549600",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14543037166636889547&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.990933,
          -26.102231
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Randburg",
        "description": "Outdoor Warehouse | Randburg",
        "address": "Shop L01, Ferndale Mall on Republic, Republic Drive, Randburg, Johannesburg, Randburg, Gauteng, 2194, South Africa",
        "city": "Randburg",
        "state_province": "Gauteng",
        "postal_code": "2194",
        "country": "South Africa",
        "phone": "010 900 0336",
        "email": "randburg@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1683036803683707530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.012511,
          -26.01652
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Fourways",
        "description": "Outdoor Warehouse | Fourways",
        "address": "Cnr William Nicol Dr & Sunrise Blvd, Shop G4, Fourways Crossing, Lone Hill, Sandton, Johannesburg North, Sandton, Gauteng, 2191, South Africa",
        "city": "Sandton",
        "state_province": "Gauteng",
        "postal_code": "2191",
        "country": "South Africa",
        "phone": "011 465 2051",
        "email": "admin-fourways@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10158467096824094190&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.011532,
          -26.030718
        ]
      },
      "properties": {
        "title": "Iconomy | Design Quarter",
        "description": "Iconomy | Design Quarter",
        "address": "Design Quarter Shopping Centre, Magaliessig, Sandton, Johannesburg, Gauteng, 2067, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2067",
        "country": "South Africa",
        "phone": "0825391560",
        "website": "http://www.iconomyonline.com/",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7076348614072237609&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.013195,
          -25.993008
        ]
      },
      "properties": {
        "title": "The Pantry Collection",
        "description": "The Pantry Collection",
        "address": "Shop 47, Dainfern Square, 2040 Broadacres drive, Midrand, Gauteng, 2191, South Africa",
        "city": "Midrand",
        "state_province": "Gauteng",
        "postal_code": "2191",
        "country": "South Africa",
        "phone": "084 599 9670",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10969857559694101469&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.013195,
          -25.993008
        ]
      },
      "properties": {
        "title": "Pantry Collection",
        "description": "Pantry Collection",
        "address": "2040 Broadacres Dr, Fourways, Sandton, Gauteng, 2055, South Africa",
        "city": "Sandton",
        "state_province": "Gauteng",
        "postal_code": "2055",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10969857559694101469&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.019999,
          -26.052807
        ]
      },
      "properties": {
        "title": "Iconomy | Nicolway",
        "description": "Iconomy | Nicolway",
        "address": "Shop L11 Nicolway Shopping Centre, William Nicol Dr &, Wedgewood Link Rd, Bryanston, Johannesburg, Gauteng, 2191, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2191",
        "country": "South Africa",
        "phone": "0825391560",
        "email": "https://iconomyonline.com/",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7911567146691070897&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.052061,
          -26.109395
        ]
      },
      "properties": {
        "title": "Yuppiechef | Sandton City",
        "description": "Yuppiechef | Sandton City",
        "address": "83 Rivonia Rd, Sandhurst, Sandton, Sandton, Gauteng, 2196, South Africa",
        "city": "Sandton",
        "state_province": "Gauteng",
        "postal_code": "2196",
        "country": "South Africa",
        "phone": "+27104467711",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1229212881156910920&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.060161,
          -26.03651
        ]
      },
      "properties": {
        "title": "Safari Outdoor | Johannesburg",
        "description": "Safari Outdoor | Johannesburg",
        "address": "3 Achter Road, Sunninghill, Johannesburg, Gauteng, 2157, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2157",
        "country": "South Africa",
        "phone": "086 114 3545",
        "website": "https://safarioutdoor.co.za",
        "email": "info@so.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8081340280923262401&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.060161,
          -26.03651
        ]
      },
      "properties": {
        "title": "Safari Outdoor | Rivionia",
        "description": "Safari Outdoor | Rivionia",
        "address": "Rivonia Crossing II, 3 Achter Rd, Rivonia, Johannesburg, Gauteng, 2157, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2157",
        "country": "South Africa",
        "phone": "086 114 3545",
        "website": "https://safarioutdoor.co.za/",
        "email": "info@so.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8081340280923262401&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.060826,
          -26.083642
        ]
      },
      "properties": {
        "title": "Yuppiechef | Morningside",
        "description": "Yuppiechef | Morningside",
        "address": "Shop L26, Cnr of Rivonia and, Outspan Rd, Morningside, Sandton, Johannesburg, Gauteng, 2196, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2196",
        "country": "South Africa",
        "phone": "+27104439712",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17936464360010604819&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.066703,
          -26.280171
        ]
      },
      "properties": {
        "title": "The Pantry by Marble | Bassonia",
        "description": "The Pantry by Marble | Bassonia",
        "address": "Omni Square Bassionia Shopping Centre, Bassionia, Johannesburg, Gauteng, 2000, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "2000",
        "country": "South Africa",
        "phone": "010 142 5266",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12558961664805797615&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.092355,
          -26.048057
        ]
      },
      "properties": {
        "title": "Kitchenique",
        "description": "Kitchenique",
        "address": "58 Woodmead Retail Park, 1 Waterval Crescent, Woodmead, Sandton, Gauteng, 2191, South Africa",
        "city": "Sandton",
        "state_province": "Gauteng",
        "postal_code": "2191",
        "country": "South Africa",
        "phone": "011 804 5826",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6457791110676073038&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.091432,
          -26.053883
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Woodmead",
        "description": "Outdoor Warehouse | Woodmead",
        "address": "18 Waterval Cres, Livingstones Lifestyle Centre, Woodmead, Sandton, Sandton, Gauteng, 2191, South Africa",
        "city": "Sandton",
        "state_province": "Gauteng",
        "postal_code": "2191",
        "country": "South Africa",
        "phone": "011 656 3903",
        "email": "woodmead@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15461321663604951843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.107181,
          -26.014599
        ]
      },
      "properties": {
        "title": "Yuppiechef | Mall of Africa",
        "description": "Yuppiechef | Mall of Africa",
        "address": "Mall of Africa, Magwa Cres, Waterval 5-Ir, Midrand,, Johannesburg, Gauteng, 1686, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "1686",
        "country": "South Africa",
        "phone": "+27104467712",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3477317953755484102&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.118188,
          -26.18063
        ]
      },
      "properties": {
        "title": "Yuppiechef | Eastgate",
        "description": "Yuppiechef | Eastgate",
        "address": "Yuppiechef - Eastgate, Shop number L56B & L56C, Eastgate Shopping Centre, 43 Bradford Rd, Bedfordview, Germiston, Gauteng, 2008, South Africa",
        "city": "Germiston",
        "state_province": "Gauteng",
        "postal_code": "2008",
        "country": "South Africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14939712158970502446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.127082,
          -26.278381
        ]
      },
      "properties": {
        "title": "Yuppiechef | Newmarket",
        "description": "Yuppiechef | Newmarket",
        "address": "Shop 59, and Ring road East, 6 Heidelberg Rd, Newmarket Park, Alberton, Johannesburg, Gauteng, 1449, South Africa",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "1449",
        "country": "South Africa",
        "phone": "0101576460",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1920716626655017807&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.126719,
          -26.27827
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Alberton",
        "description": "Outdoor Warehouse | Alberton",
        "address": "Cnr Heidelberg & Ascot Rd, Shop 25, Mall at Newmarket, Newmarket Park, Alberton, Johannesburg South, Alberton, Gauteng, 1449, South Africa",
        "city": "Alberton",
        "state_province": "Gauteng",
        "postal_code": "1449",
        "country": "South Africa",
        "phone": "011 907 5511",
        "website": "https://www.outdoorwarehouse.co.za/store/outdoor-warehouse-alberton?srsltid=AfmBOoqnCfIOlzJj9OAajwFxgizNtZ-WxCCohHTV4vcAKDa6Cuiy_x1E",
        "email": "admin-alberton@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9446787490740182852&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.133859,
          -26.273597
        ]
      },
      "properties": {
        "title": "Braai Shack | Verwoerdpark",
        "description": "Braai Shack | Verwoerdpark",
        "address": "184 Second Avenue Florentia Alberton, Alberton, Gauteng, 1449, South Africa",
        "city": "Alberton",
        "state_province": "Gauteng",
        "postal_code": "1449",
        "country": "South Africa",
        "phone": "+27 79 013 8978",
        "email": "charmaine.meintjes37@gmail.com",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13383266271524334838&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.190098,
          -25.865949
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Centurion",
        "description": "Outdoor Warehouse | Centurion",
        "address": "Centurion Gate CNR John Vorster Drive & Akkerboom Street Zwartkop, Centurion, Gauteng, 0157, South Africa",
        "city": "Centurion",
        "state_province": "Gauteng",
        "postal_code": "0157",
        "country": "South Africa",
        "phone": "(012) 663 1450",
        "email": "centurion@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17766203471461789665&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.192753,
          -25.863075
        ]
      },
      "properties": {
        "title": "Home Fires | Centurion",
        "description": "Home Fires | Centurion",
        "address": "1306 South Street Centurion, Cr of South St and Kwartsiet St, Zwartkop, Centurion, Gauteng, 0157, South Africa",
        "city": "Centurion",
        "state_province": "Gauteng",
        "postal_code": "0157",
        "country": "South Africa",
        "phone": "0129519411",
        "website": "http://www.homefires.co.za/",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11709958221130098285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.194228,
          -25.916577
        ]
      },
      "properties": {
        "title": "The Biltong Shop",
        "description": "The Biltong Shop",
        "address": "Shop 12 Ashford St, Midstream Estate, Olifantsfontein, Olifantsfontein, Gauteng, 1692, South Africa",
        "city": "Olifantsfontein",
        "state_province": "Gauteng",
        "postal_code": "1692",
        "country": "South Africa",
        "phone": "082 783 0702",
        "email": "annelielewies@gmail.com",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16630707865740356748&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.189508,
          -25.842311
        ]
      },
      "properties": {
        "title": "Local Is Lekker",
        "description": "Local Is Lekker",
        "address": "52 Queen street, Irene, Centurion, Gauteng, 0157, South Africa",
        "city": "Centurion",
        "state_province": "Gauteng",
        "postal_code": "0157",
        "country": "South Africa",
        "phone": "0822178557",
        "email": "info@localislekkerza.co.za",
        "regions": [
          "Gauteng"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.231371,
          -26.179934
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Boksburg",
        "description": "Outdoor Warehouse | Boksburg",
        "address": "Rocnic Industrial Park 75 North Rand Road Hughes, Boksburg, Gauteng, 1459, South Africa",
        "city": "Boksburg",
        "state_province": "Gauteng",
        "postal_code": "1459",
        "country": "South Africa",
        "phone": "(011) 823 3110",
        "email": "boksburg@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=11046042723542961922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.234308,
          -25.772382
        ]
      },
      "properties": {
        "title": "Yuppiechef | Brooklyn",
        "description": "Yuppiechef | Brooklyn",
        "address": "Shop 251, Brooklyn Mall, Cnr Veale Street and Fehrsen St, Pretoria, Gauteng, 0145, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0145",
        "country": "South Africa",
        "phone": "+27128802765",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3836617376383621675&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.238572,
          -26.187095
        ]
      },
      "properties": {
        "title": "Heatwave",
        "description": "Heatwave",
        "address": "111 Rietfontein Rd, Dunmadeley, Boksburg, Gauteng, 1459, South Africa",
        "city": "Boksburg",
        "state_province": "Gauteng",
        "postal_code": "1459",
        "country": "South Africa",
        "phone": "011 826 3062",
        "website": "http://www.heatwave.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16325790400871076&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.244372,
          -25.718357
        ]
      },
      "properties": {
        "title": "Big Foot Outdoor Gear",
        "description": "Big Foot Outdoor Gear",
        "address": "12 Eland Street, Zeroplus Building, Koedoespoort Road, Pretoria, Gauteng, 0184, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0184",
        "country": "South Africa",
        "phone": "0123336712",
        "email": "production@bigfootoutdoorgear.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=7699878433013197055&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.245448,
          -26.17968
        ]
      },
      "properties": {
        "title": "PET Pool & Fire | Boksburg",
        "description": "PET Pool & Fire | Boksburg",
        "address": "K90 Centre Northrand Road & Rondebult Rd, Jansen Park, Boksburg, Gauteng, 1459, South Africa",
        "city": "Boksburg",
        "state_province": "Gauteng",
        "postal_code": "1459",
        "country": "South Africa",
        "phone": "011 823 6132",
        "website": "https://www.petandpool.co.za",
        "email": "boksburg@petandpool.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2430763284057502005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.248182,
          -26.181927
        ]
      },
      "properties": {
        "title": "Safari Outdoor | East Rand",
        "description": "Safari Outdoor | East Rand",
        "address": "East Rand Retail Park, 7 Jeremy Kark's Rd, Eveleigh, Boksburg, Gauteng, 1459, South Africa",
        "city": "Boksburg",
        "state_province": "Gauteng",
        "postal_code": "1459",
        "country": "South Africa",
        "phone": "086 100 0071",
        "website": "https: //safarioutdoor.co.za/",
        "email": "info@so.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6192830373009256755&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.249148,
          -25.819481
        ]
      },
      "properties": {
        "title": "Kloppers | Pretoria",
        "description": "Kloppers | Pretoria",
        "address": "Koedoesnek Ave, Erasmus Park, Pretoria, Gauteng, 0181, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0181",
        "country": "South Africa",
        "phone": "0120514200",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4749948092871394983&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.255393,
          -25.774857
        ]
      },
      "properties": {
        "title": "The Pantry by Marble | Pretoria",
        "description": "The Pantry by Marble | Pretoria",
        "address": "The Village, 24 16th Street, Hazelwood, Menlopark, Pretoria, Gauteng, 0081, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0081",
        "country": "South Africa",
        "phone": "012 051 0385",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10115569674088126925&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.256005,
          -25.862357
        ]
      },
      "properties": {
        "title": "Trans Africa Bush Gear",
        "description": "Trans Africa Bush Gear",
        "address": "38 Regency Dr, Route 21 Business Park, Irene, Centurion, Gauteng, 0062, South Africa",
        "city": "Centurion",
        "state_province": "Gauteng",
        "postal_code": "0062",
        "country": "South Africa",
        "phone": "087 822 2264",
        "website": "https://bushgear.africa",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10519308197188744510&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.259162,
          -26.096457
        ]
      },
      "properties": {
        "title": "Noag's Market",
        "description": "Noag's Market",
        "address": "19 Pomona Road, Kempton Park, Gauteng, 1619, South Africa",
        "city": "Kempton Park",
        "state_province": "Gauteng",
        "postal_code": "1619",
        "country": "South Africa",
        "phone": "011 396 2300",
        "website": "https://noags.co.za/",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=919822662752784084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.269227,
          -25.817543
        ]
      },
      "properties": {
        "title": "Kings Meat Deli | Castle Walk",
        "description": "Kings Meat Deli | Castle Walk",
        "address": "Nossob St, Erasmuskloof, Pretoria, Gauteng, 0048, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0048",
        "country": "South Africa",
        "phone": "0123470115",
        "website": "http://www.kingsmeatdeli.co.za/",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5879249289643763952&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.272991,
          -26.034032
        ]
      },
      "properties": {
        "title": "Blooming Beautiful & Co",
        "description": "Blooming Beautiful & Co",
        "address": "Olivewood Lifestyle Centre, Kempton Park, Gauteng, 1619, South Africa",
        "city": "Kempton Park",
        "state_province": "Gauteng",
        "postal_code": "1619",
        "country": "South Africa",
        "phone": "082 467 8980",
        "email": "bloomingbeautiful@mweb.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2840793724143703100&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.273781,
          -25.682412
        ]
      },
      "properties": {
        "title": "Conqueror | Montana",
        "description": "Conqueror | Montana",
        "address": "hop 9 Montana Value Centre 1151 Tibouchina St Montana, Montana Park, Pretoria, Gauteng, 0159, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0159",
        "country": "South Africa",
        "phone": "012 524 9700",
        "email": "admin@conquerorpta.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12169388219002837324&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.275029,
          -25.682526
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Zambezi",
        "description": "Outdoor Warehouse | Zambezi",
        "address": "Shop 17/18  Montana Value Centre, CNR Sefako Makgatho drive & Calliandra Street Montanapark, Pretoria, Gauteng, 0182, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0182",
        "country": "South Africa",
        "phone": "(012) 548 3170",
        "email": "zambezi@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4677359419187267408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.274663,
          -25.783155
        ]
      },
      "properties": {
        "title": "Yuppiechef | Menlyn Park",
        "description": "Yuppiechef | Menlyn Park",
        "address": "Shop G73, Menlyn Park, Cnr Atterbury Road and Lois Ave, Pretoria, Gauteng, 0063, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0063",
        "country": "South Africa",
        "phone": "+27128802764",
        "gmaps_uri": "https://maps.google.com/?cid=14502908742662925313&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.278436,
          -25.765262
        ]
      },
      "properties": {
        "title": "Kings Meat Deli | Lynnwood Bridge",
        "description": "Kings Meat Deli | Lynnwood Bridge",
        "address": "Lynnwood Bridge Retail, Lynnwood Rd & Daventry Rd, Lynnwood Manor, Pretoria, Gauteng, 0081, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0081",
        "country": "South Africa",
        "phone": "0123482189",
        "website": "https://www.kingsmeatdeli.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10662838831381318739&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.279252,
          -25.765447
        ]
      },
      "properties": {
        "title": "Safari Outdoor | Pretoria",
        "description": "Safari Outdoor | Pretoria",
        "address": "Lynnwood Bridge Centre, Cnr Lynnwood Road and Daventry Road, Pretoria, Gauteng, 0081, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0081",
        "country": "South Africa",
        "phone": "086 122 2269",
        "website": "https://safarioutdoor.co.za/",
        "email": "info@so.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6393942555691105044&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.310464,
          -28.227676
        ]
      },
      "properties": {
        "title": "Point S",
        "description": "Point S",
        "address": "7 Pretorius St, Bethlehem, Free State, 9701, South Africa",
        "city": "Bethlehem",
        "state_province": "Free State",
        "postal_code": "9701",
        "country": "South Africa",
        "phone": "0583031327",
        "website": "http://www.point-s.co.za/",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17386203037290856009&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.315915,
          -25.825855
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Woodlands",
        "description": "Outdoor Warehouse | Woodlands",
        "address": "Garsfontein Rd, Shop 3108, Woodlands Boulevard, Pretoriuspark, Pretoria, Pretoria, Gauteng, 0182, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0182",
        "country": "South Africa",
        "phone": "012 997 2370",
        "email": "woodlands@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4627483909046318544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.313866,
          -25.823972
        ]
      },
      "properties": {
        "title": "Yuppiechef | Woodlands",
        "description": "Yuppiechef | Woodlands",
        "address": "Cnr Garsfontein Rd &, De Villebois Mareuil Dr, Pretorius Park, Pretoria, Cape Town, Gauteng, 0081, South Africa",
        "city": "Cape Town",
        "state_province": "Gauteng",
        "postal_code": "0081",
        "country": "South Africa",
        "phone": "0121410204",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17916555928511700124&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.351312,
          -25.776338
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Pretoria East",
        "description": "Outdoor Warehouse | Pretoria East",
        "address": "Shop UL 02  Six Fountains Lifestyle & Decor Centre, Hans Strydom Drive, Six Fountains EXT 5 Silver Lakes, Pretoria, Gauteng, 0081, South Africa",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0081",
        "country": "South Africa",
        "phone": "(012) 809 1507",
        "email": "pretoriaeast@odw.co.za",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5698162205078104140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.420736,
          -28.514597
        ]
      },
      "properties": {
        "title": "Kuier Collection",
        "description": "Kuier Collection",
        "address": "Shop 4, Sandstone Square, 6 Market Street West, Clarens, Free State, 9707, South Africa",
        "city": "Clarens",
        "state_province": "Free State",
        "postal_code": "9707",
        "country": "South Africa",
        "phone": "0837078082",
        "website": "http://www.kuiercollection.co.za/",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4613175845944021377&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.422145,
          -28.514045
        ]
      },
      "properties": {
        "title": "Rooiberge Trading",
        "description": "Rooiberge Trading",
        "address": "Shop 5, Windmill Centre, 365 Main Street, Clarens, Free State, 9707, South Africa",
        "city": "Clarens",
        "state_province": "Free State",
        "postal_code": "9707",
        "country": "South Africa",
        "phone": "079 319 1683",
        "email": "smithcoffeeco@gmail.com",
        "regions": [
          "Free State"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15311861885340045028&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.267046,
          -25.886365
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Witbank",
        "description": "Outdoor Warehouse | Witbank",
        "address": "Mandela St, Highveld Mall, Emalahleni, Witbank, Mpumalanga, 1034, South Africa",
        "city": "Witbank",
        "state_province": "Mpumalanga",
        "postal_code": "1034",
        "country": "South Africa",
        "phone": "013 692 5700",
        "email": "admin-witbank@odw.co.za",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17197830720260144093&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.45608,
          -23.885525
        ]
      },
      "properties": {
        "title": "4x4 Megaworld | Polokwane",
        "description": "4x4 Megaworld | Polokwane",
        "address": "73B 19th Ave, Industria St, Polokwane, Limpopo, 0699, South Africa",
        "city": "Polokwane",
        "state_province": "Limpopo",
        "postal_code": "0699",
        "country": "South Africa",
        "phone": "0152977498",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13948668149412649650&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.460666,
          -25.807335
        ]
      },
      "properties": {
        "title": "Café Barista",
        "description": "Café Barista",
        "address": "37 Dolerite Crescent, Middelburg, Mpumalanga, 1050, South Africa",
        "city": "Middelburg",
        "state_province": "Mpumalanga",
        "postal_code": "1050",
        "country": "South Africa",
        "phone": "010 590 1237",
        "email": "cafebaristamiddelburg@gmail.com",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12138439002540095399&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.458788,
          -25.809213
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Middelburg",
        "description": "Outdoor Warehouse | Middelburg",
        "address": "Shop 24, @ Retail Centre, 35 Dolerite Crescent, Aerorand, Middelburg, Middelburg, Mpumalanga, 1050, South Africa",
        "city": "Middelburg",
        "state_province": "Mpumalanga",
        "postal_code": "1050",
        "country": "South Africa",
        "phone": "013 120 4177",
        "email": "middelburg@odw.co.za",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9413613843745936445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.512614,
          -23.872933
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Polokwane",
        "description": "Outdoor Warehouse | Polokwane",
        "address": "The Farmyard Trading Post, Cnr Munnik & School Road, Bendor Ext 115, Polokwane, Polokwane, Limpopo, 0700, South Africa",
        "city": "Polokwane",
        "state_province": "Limpopo",
        "postal_code": "0700",
        "country": "South Africa",
        "phone": "(015) 753 0350",
        "email": "polokwane@odw.co.za",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13237980654684231504&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.47457,
          -28.989617
        ]
      },
      "properties": {
        "title": "Farm Friends",
        "description": "Farm Friends",
        "address": "Farm Friends, Berg Air Lifestyle Centre, R600, Central Drakensberg,, Winterton, KwaZulu-Natal, 3340, South Africa",
        "city": "Winterton",
        "state_province": "KwaZulu-Natal",
        "postal_code": "3340",
        "country": "South Africa",
        "phone": "0834681450",
        "email": "office@highfield.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=17238411960453863244&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          29.792985,
          -25.833292
        ]
      },
      "properties": {
        "title": "Farmers Bistro",
        "description": "Farmers Bistro",
        "address": "Farmers Bistro ALZU Petroport N4 Portion 35 Wonderfontein between Middelburg and Belfast, Middelburg, Mpumalanga, 1101, South Africa",
        "city": "Middelburg",
        "state_province": "Mpumalanga",
        "postal_code": "1101",
        "country": "South Africa",
        "email": "tiaan@alzu.co.za",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1323806861089789715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.152957,
          -23.833693
        ]
      },
      "properties": {
        "title": "Beefmar",
        "description": "Beefmar",
        "address": "6 Boundary Street, Arbor Park, Tzaneen, Limpopo, 0850, South Africa",
        "city": "Tzaneen",
        "state_province": "Limpopo",
        "postal_code": "0850",
        "country": "South Africa",
        "phone": "063 757 2751",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=13260477562028226115&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.154056,
          -29.464815
        ]
      },
      "properties": {
        "title": "Smokeless Fires",
        "description": "Smokeless Fires",
        "address": "R103, Howick, Lions River, Howick, Lions River, KwaZulu-Natal, 3260, South Africa",
        "city": "Lions River",
        "state_province": "KwaZulu-Natal",
        "postal_code": "3260",
        "country": "South Africa",
        "phone": "0652700935",
        "website": "http://www.smokelessfires.com/",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=14947750653428587388&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.15514,
          -23.828445
        ]
      },
      "properties": {
        "title": "Du Life Tzaneen",
        "description": "Du Life Tzaneen",
        "address": "43 Boundary St, Arbor Park, Tzaneen, Limpopo, 0850, South Africa",
        "city": "Tzaneen",
        "state_province": "Limpopo",
        "postal_code": "0850",
        "country": "South Africa",
        "phone": "015 307 2151",
        "website": "https://dulife.co.za/?fbclid=PAZXh0bgNhZW0CMTEAAacyRITKsYON-sjfB7VFFlhylIokNkaEkFFYvWi2EG4PYoYujv7IuI8nJQk5hg_aem_gjFwsdT-Zxhh17qQyxp52A",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4255888630020143804&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.356415,
          -29.571308
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Pietermaritzburg",
        "description": "Outdoor Warehouse | Pietermaritzburg",
        "address": "Mc Carthy Dr, Shop G108, Cascades Lifestyle Centre, Chase Valley Downs, Pietermaritzburg, Pietermaritzburg, KwaZulu-Natal, 3201, South Africa",
        "city": "Pietermaritzburg",
        "state_province": "KwaZulu-Natal",
        "postal_code": "3201",
        "country": "South Africa",
        "phone": "033 347 0404",
        "email": "pietermaritzburg@odw.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12751435310688064307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.814551,
          -29.750923
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Hillcrest",
        "description": "Outdoor Warehouse | Hillcrest",
        "address": "142 Inanda Road, Shop 26 Link Hills Lifestyle Centre, Waterfall, Hillcrest, Hillcrest, KwaZulu-Natal, 3652, South Africa",
        "city": "Hillcrest",
        "state_province": "KwaZulu-Natal",
        "postal_code": "3652",
        "country": "South Africa",
        "phone": "031 350 3722",
        "email": "hillcrest@odw.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3927035851372374791&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.929118,
          -24.364182
        ]
      },
      "properties": {
        "title": "The Farmhouse Shoppe",
        "description": "The Farmhouse Shoppe",
        "address": "Stand 1426 Zandspruit Boulevard, Hoedspruit, Limpopo, 1380, South Africa",
        "city": "Hoedspruit",
        "state_province": "Limpopo",
        "postal_code": "1380",
        "country": "South Africa",
        "email": "sarah@thefarmhouse.africa",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9386222435599006634&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.947075,
          -24.355578
        ]
      },
      "properties": {
        "title": "MJ’s Photographic",
        "description": "MJ’s Photographic",
        "address": "Shop 7, Kamogelo Centre, Hoedspruit, Limpopo, 1380, South Africa",
        "city": "Hoedspruit",
        "state_province": "Limpopo",
        "postal_code": "1380",
        "country": "South Africa",
        "phone": "015 793 0799",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18360501673004722292&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.956796,
          -25.470383
        ]
      },
      "properties": {
        "title": "Yuppiechef | Ilanga Mall",
        "description": "Yuppiechef | Ilanga Mall",
        "address": "Corner of Bitterbessie &, Flamboyant St, West Acres, Mbombela, Mbombela, Mpumalanga, 1200, South Africa",
        "city": "Mbombela",
        "state_province": "Mpumalanga",
        "postal_code": "1200",
        "country": "South Africa",
        "phone": "0135910381",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18336517413772782453&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.955483,
          -24.35102
        ]
      },
      "properties": {
        "title": "Fat Franks Butcher",
        "description": "Fat Franks Butcher",
        "address": "Lebamba Centre, 192 Python St, Hoedspruit, Hoedspruit, Limpopo, 1380, South Africa",
        "city": "Hoedspruit",
        "state_province": "Limpopo",
        "postal_code": "1380",
        "country": "South Africa",
        "phone": "087 655 1421",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=18196645322738087081&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.957972,
          -24.350583
        ]
      },
      "properties": {
        "title": "The Great Outdoors",
        "description": "The Great Outdoors",
        "address": "Shop No. 5, Pick n Pay Centre, Hoedspruit Wildlife Estate, Hoedspruit, Limpopo, 1380, South Africa",
        "city": "Hoedspruit",
        "state_province": "Limpopo",
        "postal_code": "1380",
        "country": "South Africa",
        "phone": "015 793 2200",
        "website": "https://thegreatoutdoors.co.za/",
        "email": "shop@thegreatoutdoors.co.za",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3539361394629312610&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.964262,
          -25.443901
        ]
      },
      "properties": {
        "title": "Conqueror",
        "description": "Conqueror",
        "address": "Shop 6 Riverside Junction, R40 Madiba Drive Riverside, Nelspruit, Mpumalanga, 1200, South Africa",
        "city": "Nelspruit",
        "state_province": "Mpumalanga",
        "postal_code": "1200",
        "country": "South Africa",
        "phone": "0832214512",
        "email": "admin@conquerornel.co.za",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=330541038608336405&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.967529,
          -25.471962
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Nelspruit",
        "description": "Outdoor Warehouse | Nelspruit",
        "address": "Crossing Centre, Cnr Samora Machel &, Madiba Dr, West Acres, Mbombela, Mpumalanga, 1201, South Africa",
        "city": "Mbombela",
        "state_province": "Mpumalanga",
        "postal_code": "1201",
        "country": "South Africa",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12509877716839595171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.974927,
          -25.473296
        ]
      },
      "properties": {
        "title": "Camp & Gas",
        "description": "Camp & Gas",
        "address": "49 Brown St, Sonheuwel Central, Mbombela, Mpumalanga, 1201, South Africa",
        "city": "Mbombela",
        "state_province": "Mpumalanga",
        "postal_code": "1201",
        "country": "South Africa",
        "phone": "0137525539",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16823655632144149993&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.977594,
          -25.470192
        ]
      },
      "properties": {
        "title": "Farmers Meat Supply Slaghuis",
        "description": "Farmers Meat Supply Slaghuis",
        "address": "10 Voortrekker Street, Nelspruit, Mpumalanga, 1200, South Africa",
        "city": "Nelspruit",
        "state_province": "Mpumalanga",
        "postal_code": "1200",
        "country": "South Africa",
        "phone": "0829209083",
        "email": "Sonja@farmersmeats.co.za",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16374369800110832992&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.989293,
          -29.810878
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Springfield",
        "description": "Outdoor Warehouse | Springfield",
        "address": "Cnr Umgeni Rd & Ilala Ave, Shop M9, Springfield Retail Centre, Umgeni Business Park, Durban, Springfield, KwaZulu-Natal, 4001, South Africa",
        "city": "Springfield",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4001",
        "country": "South Africa",
        "phone": "031 263 0851",
        "email": "springfield@odw.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6184462186610641537&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.995189,
          -25.472007
        ]
      },
      "properties": {
        "title": "Safari Outdoor Country | Nelspruit",
        "description": "Safari Outdoor Country | Nelspruit",
        "address": "Valley Hyper Shopping Centre, Corner Samora Drive and Du Preez St, Mbombela, Mpumalanga, 1200, South Africa",
        "city": "Mbombela",
        "state_province": "Mpumalanga",
        "postal_code": "1200",
        "country": "South Africa",
        "phone": "013 813 5500",
        "regions": [
          "Mpumalanga"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=5141362824557000781&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.053407,
          -29.711121
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Cornubia",
        "description": "Outdoor Warehouse | Cornubia",
        "address": "Flanders Dr, Shop U106, Cornubia Mall, Blackburn Estate, Blackburn, Kwazulu Natal, Blackburn, KwaZulu-Natal, 4302, South Africa",
        "city": "Blackburn",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4302",
        "country": "South Africa",
        "phone": "031 502 2637",
        "email": "cornubia@odw.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=8559882482959040303&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.065399,
          -29.725912
        ]
      },
      "properties": {
        "title": "Yuppiechef | Gateway",
        "description": "Yuppiechef | Gateway",
        "address": "Yuppiechef - Gateway, Shop F230 Gateway Theatre of Shopping, 1 Palm Blvd, Umhlanga Ridge, uMhlanga, KwaZulu-Natal, 4021, South Africa",
        "city": "uMhlanga",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4021",
        "country": "South Africa",
        "phone": "+27319407058",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4765371035120694820&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.110152,
          -17.789225
        ]
      },
      "properties": {
        "title": "The Braai Shop",
        "description": "The Braai Shop",
        "address": "Ed ma, Harare, Zimbabwe, Harare, Zimbabwe, Zimbabwe",
        "city": "Harare",
        "state_province": "Zimbabwe",
        "postal_code": "",
        "country": "Zimbabwe",
        "phone": "+263 78 674 4772",
        "gmaps_uri": "https://maps.google.com/?cid=11895798692056335347&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.200415,
          -29.525749
        ]
      },
      "properties": {
        "title": "Yuppiechef | Ballito",
        "description": "Yuppiechef | Ballito",
        "address": "Yuppiechef - Ballito Lifestyle Centre, Shop 39 Cnr 398/445 Main Road Main Road Dolphin Coast, Ballito, KwaZulu-Natal, 4420, South Africa",
        "city": "Ballito",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4420",
        "country": "South Africa",
        "phone": "+27319407129",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4319433058501169879&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.201604,
          -29.52693
        ]
      },
      "properties": {
        "title": "The Gentry | Ballito",
        "description": "The Gentry | Ballito",
        "address": "Shop 62 Shop 62 Lifestyle Shopping Centre, Ballito Dr, Ballito, Dolphin Coast, Ballito, KwaZulu-Natal, 4420, South Africa",
        "city": "Ballito",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4420",
        "country": "South Africa",
        "phone": "032 815 2939",
        "website": "https://www.thegentry.co.za/",
        "email": "nick@thegentry.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=6575036634318933589&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.201598,
          -29.527869
        ]
      },
      "properties": {
        "title": "Outdoor Warehouse | Ballito",
        "description": "Outdoor Warehouse | Ballito",
        "address": "Shop No 65dr, Ballito Lifestyle Centre, Cnr 398 & 445 Main Road, Ballito, Ballito, KwaZulu-Natal, 4420, South Africa",
        "city": "Ballito",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4420",
        "country": "South Africa",
        "phone": "021 914 1357",
        "email": "ballito@odw.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10717089309073141162&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.20143,
          -29.527218
        ]
      },
      "properties": {
        "title": "Cookin Stores",
        "description": "Cookin Stores",
        "address": "Shop 87B, Lifestyle Centre Cnr 398 & 498, Main Road, Ballito, Dolphin Coast, Ballito, KwaZulu-Natal, 4420, South Africa",
        "city": "Ballito",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4420",
        "country": "South Africa",
        "phone": "032 648 0046",
        "website": "https://cookinstores.co.za/",
        "email": "adrie@cookinstores.co.za",
        "priority": "25",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=10719181835346937609&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.180697,
          -29.491627
        ]
      },
      "properties": {
        "title": "Ngozi Collection",
        "description": "Ngozi Collection",
        "address": "Ngozi Collection, Sugar Rush Park, x1 Esenembe Rd, Compensation, Ballito, KwaZulu-Natal, 4420, South Africa",
        "city": "Ballito",
        "state_province": "KwaZulu-Natal",
        "postal_code": "4420",
        "country": "South Africa",
        "phone": "082 2541 483",
        "email": "info@ngozi.co.za",
        "regions": [
          "KwaZulu-Natal"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9261168620710671160&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          153.063397,
          -26.786514
        ]
      },
      "properties": {
        "title": "Oz Braai",
        "description": "Oz Braai",
        "address": "SHOP Unit 3, 10 - 12 Claude Boyd Parade, Bells Creek, Queensland, 4551, Australia",
        "city": "Queensland",
        "state_province": "Australia",
        "postal_code": "4551",
        "country": "Australia",
        "phone": "(07) 5437 0039",
        "website": "https://www.ozbraai.com.au",
        "gmaps_uri": "https://maps.google.com/?cid=7043943639691814669&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          20.338147,
          -28.593026
        ]
      },
      "properties": {
        "title": "Augrabies Falls Shop",
        "gmaps_uri": "https://maps.google.com/?cid=6692235659923705193&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
        "description": "Augrabies Falls Shop",
        "address": "Augrabies Falls Shop, Augrabies National Park, Augrabies, Augrabies, Northern Cape, 8874, South Africa",
        "city": "Augrabies",
        "state_province": "Northern Cape",
        "postal_code": "8874",
        "country": "South Africa",
        "email": "augrabiesfallsshop@outlook.com",
        "regions": [
          "Northern Cape"
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.854077,
          -33.981689
        ]
      },
      "properties": {
        "title": "Die Hoek Motors",
        "description": "Die Hoek Motors",
        "address": "59 Watergang Street, Aan de Weber Estate, Jamestown, Stellenbosch, Western Cape, 7600, South Africa",
        "city": "Stellenbosch",
        "state_province": "Western Cape",
        "postal_code": "7600",
        "country": "South Africa",
        "email": "carlakoekemoer23@gmail.com",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=15854749449917463732&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          31.119075,
          -17.783173
        ]
      },
      "properties": {
        "title": "Supreme Butchery | Zimbabwe",
        "gmaps_uri": "",
        "description": "Supreme Butchery | Zimbabwe",
        "address": "Chisipite Shopping Centre, Harare, Zimbabwe",
        "city": "Harare",
        "state_province": "Zimbabwe",
        "postal_code": "",
        "country": "Zimbabwe",
        "phone": "+263 24 2490911",
        "email": "orders@supremebutchery.co.zw"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.850594,
          -26.029109
        ]
      },
      "properties": {
        "title": "Rhino 4X4",
        "description": "Rhino 4X4",
        "address": "Unit 9, Muldersway Industrial Park, 1 St Antonios Rd, Muldersdrift, 1747",
        "city": "Johannesburg",
        "state_province": "Gauteng",
        "postal_code": "1747",
        "country": "South Africa",
        "phone": "010 595 0229",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=4812569360184624064&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          28.270164,
          -25.808369
        ]
      },
      "properties": {
        "title": "LOCK N LOAD",
        "description": "LOCK N LOAD",
        "address": "461 Lois Ave, Erasmuskloof, 0181",
        "city": "Pretoria",
        "state_province": "Gauteng",
        "postal_code": "0181",
        "country": "South Africa",
        "phone": "0620759670",
        "regions": [
          "Gauteng"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=16628080753450099173&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.033772,
          -33.090294
        ]
      },
      "properties": {
        "title": "SPAR Langebaan",
        "description": "SPAR Langebaan",
        "address": "Koewheni Centre, Oostewal St, Langebaan, 7357",
        "city": "Langebaan",
        "state_province": "Western Cape",
        "postal_code": "7357",
        "country": "South Africa",
        "phone": "0227722670",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=12006048325782430909&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.874448,
          -33.404515
        ]
      },
      "properties": {
        "title": "Eight Feet Village",
        "description": "Eight Feet Village",
        "address": "Bothmaskloof Pass R46 Riebeek Kasteel, 7307",
        "city": "Riebeek Kasteel",
        "state_province": "Western Cape",
        "postal_code": "7307",
        "country": "South Africa",
        "phone": "0664056431",
        "website": "https://www.eightfeet.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=9863696042450381201&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.885959,
          -34.149448
        ]
      },
      "properties": {
        "title": "GB Gas and Ice",
        "description": "GB Gas and Ice",
        "address": "Unit 3, 5 Mansfield Cres, Mansfield, Cape Town, 7140, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7140",
        "country": "South Africa",
        "phone": "021 856 1855",
        "website": "http://www.gbgasandice.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=767223111279476540&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          27.045783,
          -33.531433
        ]
      },
      "properties": {
        "title": "The Local Farmstall & Co",
        "description": "The Local Farmstall & Co",
        "address": "45 Dias Rd, Seafield, South Africa",
        "city": "Cape Town",
        "state_province": "Eastern Cape",
        "postal_code": "6172",
        "country": "South Africa",
        "phone": "0826566988",
        "email": "thelocal@guidosco.co.za",
        "regions": [
          "Eastern Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=2676255349342902259&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          18.848573,
          -34.079283
        ]
      },
      "properties": {
        "title": "Modern Electric Appliances & Furniture",
        "description": "Modern Electric Appliances & Furniture",
        "address": "No. 2 Lourensford Rd, Somerset West, Cape Town, 7130, South Africa",
        "city": "Cape Town",
        "state_province": "Western Cape",
        "postal_code": "7130",
        "country": "South Africa",
        "phone": "0218521544",
        "email": "sales@modernappliances.co.za",
        "website": "https://www.modernappliances.co.za/",
        "regions": [
          "Western Cape"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=3546976313931711525&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          30.861897,
          -24.388781
        ]
      },
      "properties": {
        "title": "Driehoek Butcher Shop",
        "description": "Driehoek Butcher Shop",
        "address": "Cnr R527 and D1185, Hoedspruit, 1380, South Africa",
        "city": "Hoedspruit",
        "state_province": "Limpopo",
        "postal_code": "1380",
        "country": "South Africa",
        "phone": "0636125389",
        "email": "info@driehoekbutcher.co.za",
        "website": "http://www.driehoekbutcher.co.za/",
        "regions": [
          "Limpopo"
        ],
        "gmaps_uri": "https://maps.google.com/?cid=1431212598312129023&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
      }
    },
    // {
    //   "type": "Feature",
    //   "geometry": {
    //     "type": "Point",
    //     "coordinates": [
    //       23.078893,
    //       -34.046189
    //     ]
    //   },
    //   "properties": {
    //     "title": "Braai Guys",
    //     "description": "Braai Guys",
    //     "address": "Meubel St, Industrial Area, Knysna, Western Cape, 6570, South Africa",
    //     "city": "Knysna",
    //     "state_province": "Western Cape",
    //     "postal_code": "6570",
    //     "country": "South Africa",
    //     "regions": [
    //       "Western Cape"
    //     ],
    //     "gmaps_uri": "https://maps.google.com/?cid=11584620547444279175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA"
    //   }
    // },
  ]
};
